import {
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  EventEmitter,
  Output,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import _ from 'lodash-es';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { ResultComponent } from '../enter-claims-la/result/result.component';
import { FooterComponent } from '../../widgets/footer/footer.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { HomeService } from '../enter-claims-la/home/home.service';
import {
  MatCard,
  MatCardContent,
  MatCardHeader,
  MatCardTitle,
} from '@angular/material/card';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTooltip } from '@angular/material/tooltip';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { TextAreaComponent } from '../../widgets/text-area/text-area.component';
// import { TextAreaComponent } from '../../../widgets/text-area/text-area.component';
import { IraResultService } from './ira-result.service';
import { response } from 'express';
import { TextFieldModule } from '@angular/cdk/text-field';
// import { ClassificationReport } from '../../../models/classification-report.model';
// import { ClassificationResult } from '../../../models/classification-result.model';
import { HeaderComponent } from '../../widgets/layout/header/header.component';
import { LoadingService } from '../../services/loading.service';
import { ClassificationItem } from '../../models/classification-item.model';
import { ClassificationReport } from '../../models/classification-report.model';
import { ClassificationResult } from '../../models/classification-result.model';
import { Const } from '../../static/const';
import { ExcelService } from '../../services/excel.service';
import { PdfService } from '../../services/pdf.service';
import { SharedService } from '../../services/shared.service';
import {
  PopupType,
  AppPopupData,
  AppPopupComponent,
} from '../../widgets/app-popup/app-popup.component';
import { Document } from '../../models/document.model';
import { Page } from '../../models/page.model';
import { Converters } from '../../static/converters';
import { SafeHtml } from '@angular/platform-browser';
import { Safe } from '../../pipes/safeHtml.pipe';
import { EditorComponent, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { Common } from '../../static/common';
import { PreviewService } from '../enter-claims-la/preview/preview.service';
import { Metadata } from '../../models/metadata.model';
import { IraPopupComponent } from '../ira-popup/ira-popup.component';
import { ClickOutsideDirective } from '../../directives/app-click-outside.directive';
import { IraAlertPopupComponent } from '../../widgets/ira-alert-popup/ira-alert-popup.component';
import { NgZone } from '@angular/core';
import { ResultService } from '../enter-claims-la/result/result.service';
import { DropdownModule } from 'primeng/dropdown';
import { ClassificationResultValues } from '../../static/classification-result-values';
import { debounceTime, Subject } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { AppBrowserDetectDirective } from '../../directives/app-browser-detect.directive';
import { TooltipDirective } from '../../directives/tooltip.directive';

interface EditableResult extends ClassificationResult {
  isDeleted?: boolean;
  isLevelApproved?: boolean;
  isRiskApproved?: boolean;
  approvedReasons?: string[];
}

interface EditableReport extends ClassificationReport {
  results: EditableResult[];
}

@Component({
  selector: 'app-ira-result',
  standalone: true,
  imports: [
    MatTableModule,
    MatButton,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule,
    MatCheckboxModule,
    NgFor,
    NgClass,
    MatTooltip,
    MatToolbarModule,
    MatIconModule,
    MatInput,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    DropdownModule,
    NgIf,
    HeaderComponent,
    TextFieldModule,
    MatMenu,
    MatMenuTrigger,
    CommonModule,

    FooterComponent,
    MatRadioModule,
    Safe,
    EditorComponent,
    MatMenuModule,
    MatButtonModule,
    ClickOutsideDirective,
    ToastModule,
    AppBrowserDetectDirective,
    TooltipDirective,
  ],
  providers: [
    MessageService,
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
  ],
  templateUrl: './ira-result.component.html',
  styleUrl: './ira-result.component.scss',
})
export class IraResultComponent {
  @Input() iraTableData: any;
  @Input() fileBlobData: any;
  @Input() dataFromResult: any;
  @Input() isEditClaimsRoute: any;
  @ViewChild('marketingSelect') marketingSelect!: MatSelect;
  @Input() data: any;
  @Input() hideHeader: boolean = false;
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  @Input() isResultPage: boolean = false;
  @Input() routeSource: any;
  @Input() editClaimsNormalRoute: any; // editClaims or normal route
  @Input() navigatedFrom: any;
  @Input() rowVisibleIra: boolean = false;
  @Input() geographyDataLA: any = [];
  @Input() marketingChannelsPreview: any;
  @Output() anyRowEdited = new EventEmitter<boolean>();
  // @ViewChild('editor') editor: EditorComponent;
  displayedColumns = [
    'slno',
    'text',
    'qualifier',
    'new_marketing_channel',
    'lifecycle',
    'page_no',
    'Label',
    'level',
    'level_model',
    'manual_level',
    'risk',
    'risk_model',
    'manual_risk',
    'reason',
    'reason_model',
    'manual_reason',
    // 'back_translations',
    // "related_translations",
    // "qualifier_translations"
  ];
  // dataSource = ELEMENT_DATA;
  public rowIndex: any;
  private editIndex: any = null;
  disclaimerIndex: any = null;
  editItem: any;
  editableReport: any;
  originalReport: any;
  private isReportChanged = false;
  eeocDocId: any;
  enableDropdowns: boolean = false;
  selectedLanguage: any;
  fileType: any;
  dataSource = new MatTableDataSource<any>([]);
  selection = new SelectionModel<any>(true, []);
  statementLanguage: any;
  options_marketing: string[] = [
    'Concept Claims',
    'Pack BOP',
    'Omnichannel',
    'E-Commerce',
    'Pack FOP',
    'E-Commerce',
    'Omnichannel',
  ];
  private globalMetadata: Metadata = {};
  manualriskoptions: string[] = ['NA', '0', '1', '2', '3'];
  optionmanualrisk = ['Low', 'Medium', 'High'];
  // manual_reason: string[] = ['NA1', 'NA2', 'NA3', 'NA4', 'NA5'];
  fileDetails: any;
  searchTerm: string;
  showStatementSearch: boolean = false;
  showQualifierSearch: boolean = false;
  isTruncated = true;
  projectValue: any;
  productValue: any;
  geographyValue: any;
  isRowVisible: boolean = false; // Initially visible
  existingQualifierValues: any = [];
  isFormatted: boolean;
  document: Document;
  currentPage: Page;
  originalData: any;
  isTextEditor = new Array(this.dataSource.data.length).fill(false);
  showMarketingFilter: boolean = false;
  marketingChannelFilter = new FormControl([]);
  originalElements: any[] = []; // Store original data
  filteredElements: any[] = [];
  textFilter = new FormControl('');
  qualifierFilter = new FormControl('');
  marketingFilter = new FormControl('');
  resultsData: any = [];
  totalValue: any;
  routeData: any;
  initialData: any;
  pageFromPreview: any;
  pageDocDetails: any;
  isToggleDisabled = false; // Add this flag
  filterValues = {
    text: '',
    qualifier: '',
    marketing_channel: [],
    // colour: '',
    // pet: ''
  };
  selectedQualifiers: any = [];
  selectedQualifiersUpdated: any = [];
  enteredQualifiers: any = [];
  showTranlsationGroup = false;
  showLanguageGroup = false;
  geographyData: any = [];

  languagesData: any = [];
  relatedStatementChecked: boolean = false;
  backtranslationChecked: boolean = false;
  radioBtnValue: string;
  languageDisabled: boolean = false;
  defaultLanguageDisbaled: boolean = true;
  selectedTranslationLanguage: any;
  isTextModified: boolean = false;
  element: any;
  marketingChannelsValues: any = [];
  previewMarketingChannels: any;
  newlyAddedRowDeleted = false;
  fileBase64data: any;
  isTranslationRowAdded: boolean = false;
  translatedTexts: any = [];
  translatedQualifierTexts: any = [];
  backTranslatedTexts: any = [];
  btnClicked: boolean = false;
  qualifierTranslationData: any = [];
  initialChange: any = true;
  showTranslatedRows = false; // LA to add translation row after initial load
  statementLanguageDisabled: any;
  isBackTranslationVisible: boolean = false;
  pageFrom: any;
  public disabledReasons: boolean[] = this.reasons.map(() => false);
  newRowHelpText = 'Get existing qualifier and marketing channel for the text';
  private autoSaveSubject = new Subject<void>();
  selectedMarketingChannels: any = [];
  routeFrom: any;
  showText = {};
  
  // @ViewChild(ResultComponent)
  // ResultComponent!: ResultComponent;

  constructor(
    public iraResultService: IraResultService,
    public loadingService: LoadingService,
    public sharedService: SharedService,
    private pdfService: PdfService,
    private excelService: ExcelService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    route: ActivatedRoute,
    private dialog: MatDialog,
    private previewService: PreviewService,
    private homeService: HomeService,
    private ngZone: NgZone,
    private resultService: ResultService,
    private messageService: MessageService
  ) {
    console.log('isResultPage', this.isResultPage);
    console.log('rowVisibleIra', this.rowVisibleIra);
    console.log('activeClaimsCount', this.activeClaimsCount > 0);

    console.log('routfrom', this.routeFrom);
    route.params.subscribe((val) => {
      // put the code from `ngOnInit` here
      console.log('val', val);
    });

    const nav = this.router.getCurrentNavigation();
    if (nav?.extras?.state) {
      this.originalReport = nav.extras.state['data'];
      this.fileDetails = nav.extras.state['fileDetails'];
      this.pageFromPreview = nav.extras.state['pageFrom'];
      this.fileBase64data = nav.extras.state['fileBase64'];
      this.previewMarketingChannels =
        nav.extras.state['previewMarketingChannels'];
      this.routeFrom = nav.extras.state['routeFrom'];
      console.log('routfrom', this.routeFrom);
      console.log('fileDetails for ira result comp', this.fileDetails);
      // this.routeSource = nav.extras.state['source'];
    } else {
      console.warn(
        'Navigation state is missing. Possibly due to page refresh.'
      );
    }
    console.log('routfrom', this.routeFrom);
    console.log('pagefrompereviewwwwwwwwww', this.pageFromPreview);

    // this.originalReport =
    //   router.getCurrentNavigation()!.extras?.state &&
    //   router.getCurrentNavigation()!.extras?.state!['data'];

    // this.fileDetails =
    //   router.getCurrentNavigation()!.extras?.state &&
    //   router.getCurrentNavigation()!.extras?.state!['fileDetails'];
    // this.pageFromPreview =
    //   router.getCurrentNavigation()!.extras?.state &&
    //   router.getCurrentNavigation()!.extras?.state!['pageFrom'];
    // console.log('pageFrom', this.pageFromPreview);

    console.log('original report', this.originalReport);
    // console.log('original report.results[9', this.originalReport[0].results);

    // this.document = this.originalReport.fileBase64[0].document;
    // this.currentPage = this.originalReport.fileBase64[0].currentPage;

    // this.document = this.originalReport.fileBase64[0].document;
    // this.currentPage = this.originalReport.fileBase64[0].currentPage;
    // this.resultsTableData(this.originalReport.results);

    //to make qualifiers filed textarea by default for master text and Asset not having any qualifiers
    // if (
    //   this.fileType == '' ||
    //   this.originalReport[0].new_qualifiers.length == 0
    // ) {
    //   this.isFormatted = true;
    // } else {
    //   this.isFormatted = false;
    // }
    // to filter empty text values
  }

  // before sonar fix
  // resultsTableData(resultsData) {
  //   console.log('results data', resultsData);
  //   if (this.dataFromResult == true) {
  //     this.originalReport = resultsData;
  //   }
  //   let results = resultsData.results;

  //   // results.filter((result) => {
  //   //   result.manual_level.map((level) => {
  //   //     return (result.manual_level = { prediction: level });
  //   //   });
  //   // });
  //   // results.filter((result) => {
  //   //   result.manual_risk.map((risk) => {
  //   //     return (result.manual_risk = { prediction: risk });
  //   //   });
  //   // });
  //   // results.filter((result) => {
  //   //   result.manual_reason.map((reason) => {
  //   //     return (result.manual_reason = { prediction: [reason] });
  //   //   });
  //   // });

  //   console.log('results', results);

  //   //to make qualifier as array
  //   results = results.map((result) => {
  //     if (typeof result.qualifiers == 'string') {
  //       result.qualifiers = [result.qualifiers];
  //     } else {
  //       result.qualifiers = result.qualifiers;
  //     }
  //     return result;
  //   });

  //   // to add selected property
  //   // results.filter((result) => {
  //   //   return (result.selected = false);
  //   // });

  //   this.fileType = localStorage.getItem('fileType');
  //   // console.log('qualifier datata', this.originalReport.qualifiers);
  //   //to make qualifiers filed textarea by default for master text and Asset not having any qualifiers
  //   // || this.originalReport.qualifiers.length == 0
  //   if (this.fileType == '' || this.originalReport.qualifiers.length == 0) {
  //     this.isFormatted = true;
  //   } else {
  //     if (resultsData.isFormatted == true) {
  //       this.isFormatted = true;
  //     } else {
  //       this.isFormatted = false;
  //     }
  //   }

  //   console.log('results 2', results);
  //   results = results.map((result, index) => {
  //     const allQualifier = [];
  //     if (result.existing_qualifier.length > 0) {
  //       result.existing_qualifier.map((res) => {
  //         if (res != '<p></p>') {
  //           allQualifier.push({
  //             type: 'old',
  //             text: res,
  //             icon: 'fa-robot',
  //           });
  //         }
  //       });
  //     }

  //     if (resultsData.qualifiers.length > 0) {
  //       resultsData.qualifiers.map((res) => {
  //         allQualifier.push({
  //           type: 'new',
  //           text: res,
  //           icon: '',
  //         });
  //       });
  //     }

  //     console.log('page from preview', this.pageFromPreview);
  //     console.log('data from result', this.dataFromResult);
  //     console.log('pageFrom', this.pageFrom);
  //     console.log('routeSource', this.routeSource);
  //     const marketingChannels: any = [];
  //     if (this.routeSource == 'Draft' && this.dataFromResult == true) {
  //       marketingChannels.push(...result.allMarketingChannels);
  //     } else {
  //       const combined = [
  //         ...result.marketing_channel,
  //         ...result.new_marketing_channel,
  //       ];
  //       combined.forEach((channel) => {
  //         if (!marketingChannels.includes(channel)) {
  //           marketingChannels.push(channel);
  //         }
  //       });
  //     }

  //     console.log('marketing channels', marketingChannels);
  //     this.existingQualifierValues[index] = allQualifier;

  //     return {
  //       ...result,
  //       sl_no: this.formatSerialNumber(index + 1),
  //       allQualifier: allQualifier,
  //       allMarketingChannels: marketingChannels,
  //       richtext: false,
  //       isNewRow: false,
  //       isEdited: false,
  //       oldText: result.text,
  //       selected: true,
  //       isUpdated: false,
  //       back_translated_text: [],
  //       translated_text: [],
  //       translated_qualifier_text: [],
  //       claimOrder: (index + 1) * 10,
  //     };
  //   });

  //   // results.filter((result) => {
  //   //   console.log('manula level', result.manual_level);
  //   //   console.log('type of manula level', typeof result.manual_level);
  //   //   if (
  //   //     typeof result.manual_level == 'string' ||
  //   //     typeof result.manual_level == 'object'
  //   //   ) {
  //   //     result.manual_level = [result.manual_level];
  //   //     result.manual_level.map((level) => {
  //   //       return (result.manual_level = { prediction: level });
  //   //     });
  //   //   } else {
  //   //     result.manual_level.map((level) => {
  //   //       return (result.manual_level = { prediction: level });
  //   //     });
  //   //   }
  //   // });
  //   // results.forEach((result) => {
  //   //   console.log('manual level:', result.manual_level);
  //   //   console.log('type of manual level:', typeof result.manual_level);

  //   // Case 1: If manual_level is already an object with a prediction key, do nothing
  //   // if (
  //   //   typeof result.manual_level === 'object' &&
  //   //   result.manual_level !== null &&
  //   //   'prediction' in result.manual_level
  //   // ) {
  //   //   return;
  //   // }

  //   // Case 2: If manual_level is a string or any other type, convert to object
  //   // result.manual_level = {
  //   //   prediction: result.manual_level || 'NA',
  //   // };
  //   // });

  //   console.log('result', results);
  //   // results.filter((result) => {
  //   //   if (
  //   //     typeof result.manual_risk == 'string' ||
  //   //     typeof result.manual_risk == 'object'
  //   //   ) {
  //   //     result.manual_risk = [result.manual_risk];
  //   //     result.manual_risk.map((risk) => {
  //   //       if (result.manual_risk.hasOwnProperty('prediction')) {
  //   //         return result.manual_risk;
  //   //       } else {
  //   //         return (result.manual_risk = { prediction: risk });
  //   //       }
  //   //     });
  //   //   } else {
  //   //     result.manual_risk.map((risk) => {
  //   //       if (result.manual_risk.hasOwnProperty('prediction')) {
  //   //         return result.manual_risk;
  //   //       } else {
  //   //         return (result.manual_risk = { prediction: risk });
  //   //       }
  //   //     });
  //   //   }
  //   // });
  //   // results.forEach((result) => {
  //   //   console.log('manual risk:', result.manual_risk);
  //   //   console.log('type of manual risk:', typeof result.manual_risk);

  //   //   // Case 1: If manual_level is already an object with a prediction key, do nothing
  //   //   if (
  //   //     typeof result.manual_risk === 'object' &&
  //   //     result.manual_risk !== null &&
  //   //     'prediction' in result.manual_risk
  //   //   ) {
  //   //     return;
  //   //   }

  //   //   // Case 2: If manual_level is a string or any other type, convert to object
  //   //   result.manual_risk = {
  //   //     prediction: result.manual_risk || 'NA',
  //   //   };
  //   // });

  //   // results.filter((result) => {
  //   //   if (
  //   //     typeof result.manual_reason == 'string' ||
  //   //     typeof result.manual_reason == 'object'
  //   //   ) {
  //   //     result.manual_reason = [result.manual_reason];
  //   //     result.manual_reason.map((reason) => {
  //   //       return (result.manual_reason = { prediction: [reason] });
  //   //     });
  //   //   } else {
  //   //     result.manual_reason.map((reason) => {
  //   //       return (result.manual_reason = { prediction: [reason] });
  //   //     });
  //   //   }
  //   // });

  //   // results.forEach((result) => {
  //   //   const reason = result.manual_reason;

  //   //   // Case 1: If manual_reason is already an object with a prediction key, do nothing
  //   //   if (
  //   //     typeof reason === 'object' &&
  //   //     reason !== null &&
  //   //     'prediction' in reason
  //   //   ) {
  //   //     return;
  //   //   }

  //   //   // Case 2: If manual_reason is a string or any other type, wrap it in prediction array
  //   //   result.manual_reason = {
  //   //     prediction: Array.isArray(reason) ? reason : [reason || 'NA'],
  //   //   };
  //   // });

  //   //to filter reason_model based on the reason value
  //   let value;
  //   for (let i = 0; i < results.length; i++) {
  //     value = results[i];
  //     // to get count of reason having 0 value
  //     const count = value.reason.filter((v) => {
  //       return v == '0';
  //     }).length;

  //     // filtering reason with 0 value
  //     value.reason = value.reason.filter((v) => {
  //       return v != '0';
  //     });

  //     //removing reason_model based on the length of the reason array
  //     for (let k = 0; k < value.reason.length; k++) {
  //       if (value.reason_keywords.length == 0) {
  //         if (value.reason.length != value.reason_model.length) {
  //           value.reason_model = value.reason_model.slice(0, -count);
  //         }
  //       }
  //     }
  //   }

  //   //to check if the route is from excel or not
  //   // this.isExcel =
  //   //   router.getCurrentNavigation()!.extras.state &&
  //   //   router.getCurrentNavigation()!.extras.state!['isExcel'];

  //   // //to check whther asset is saved or not
  //   // this.isAssetSaved =
  //   //   router.getCurrentNavigation()!.extras.state &&
  //   //   router.getCurrentNavigation()!.extras.state!['isAssetSaved'];
  //   this.originalReport.results = results;
  //   this.originalReport.total = this.getTotal(results);
  //   this.editableReport = _.cloneDeepWith(this.originalReport);
  //   console.log('original report', this.originalReport);
  //   console.log('editable reportsss', this.editableReport);
  //   this.dataSource.data = this.editableReport.results;

  //   //to check all the rows by default

  //   this.dataSource.data.forEach((row) => {
  //     if (row.selected == true) {
  //       this.selection.select(row);
  //     }
  //   });
  //   // this.isFormatted = true;
  //   console.log('data source data for toggle', this.dataSource.data);
  //   if (this.pageFromPreview == 'preview') {
  //     localStorage.removeItem('routeFrom');
  //   }
  // }

  // After sonar fix
  resultsTableData(resultsData) {
    console.log('results data', resultsData);
    const sharedRouteData = this.sharedService.getRouteData();
    console.log('sharedRouteData', sharedRouteData);
    if (this.dataFromResult == true) {
      resultsData.results = resultsData.results.filter((element: any) => {
        return element.Label?.trim().toLowerCase() == 'text';
      });
      this.originalReport = resultsData;
    }

    console.log('results before map', resultsData);
    let results =
      resultsData != undefined
        ? resultsData.results
        : sharedRouteData.resultData.results;
    console.log('results after if else', results);

    // Ensure qualifiers is always an array
    results = results.map((result) => {
      return {
        ...result,
        existing_qualifier:
          typeof result.existing_qualifier === 'string'
            ? [result.existing_qualifier]
            : result.existing_qualifier,
        qualifiers:
          typeof result.qualifiers === 'string'
            ? [result.qualifiers]
            : result.qualifiers,
      };
    });

    this.fileType = localStorage.getItem('fileType');
    let qualifierLength: any;
    if (this.originalReport) {
      qualifierLength = this.originalReport.qualifiers?.length;
    } else {
      qualifierLength = sharedRouteData.resultData.qualifiers.length;
    }

    this.isFormatted =
      this.fileType == '' || qualifierLength == 0
        ? true
        : !!resultsData.isFormatted;

    console.log('results', results);
    // results = results.map((result, index) => {
    //   const allQualifier = [];
    //   if (result.existing_qualifier.length > 0) {
    //     result.existing_qualifier.forEach((res) => {
    //       if (res != '<p></p>') {
    //         allQualifier.push({
    //           type: 'old',
    //           text: res,
    //           icon: 'fa-robot',
    //         });
    //       }
    //     });
    //   }

    //   const qualifiers =
    //     resultsData?.qualifiers?.length > 0
    //       ? resultsData.qualifiers
    //       : sharedRouteData?.resultData?.qualifiers || [];

    //   // if (resultsData.qualifiers.length > 0) {
    //   qualifiers.forEach((res) => {
    //     allQualifier.push({
    //       type: 'new',
    //       text: res,
    //       icon: '',
    //     });
    //   });
    //   // }
    //   console.log('page from', this.pageFrom);
    //   const marketingChannels: any = [];
    //   if (this.routeSource == 'Draft' && this.dataFromResult == true) {
    //     marketingChannels.push(...result.allMarketingChannels);
    //   }
    //   else if (this.dataFromResult == true) {
    //     marketingChannels.push(...result.new_marketing_channel);
    //   }
    //   else {
    //     if (sharedRouteData && sharedRouteData.pageFrom == 'iraResult' && resultsData == undefined) {
    //       marketingChannels.push(...result.allMarketingChannels);
    //     } else if (result && result?.allMarketingChannels && !sharedRouteData) {
    //       marketingChannels.push(...result.new_marketing_channel);
    //     } else {
    //       const combined = [
    //         ...result.marketing_channel,
    //         ...result.new_marketing_channel,
    //       ];
    //       combined.forEach((channel) => {
    //         if (!marketingChannels.includes(channel)) {
    //           marketingChannels.push(channel);
    //         }
    //       });
    //     }
    //   }

    //   if(this.pageFromPreview == 'preview'){
    //   const lifecycleUI:any = []
    //   if(typeof result.assessed_state == 'string'){
    //     lifecycleUI.push(result.assessed_state)
    //   } else {
    //     if(result.assessed_state[0] == 'NA'){
    //       lifecycleUI.push('None')
    //     }

    //   }

    //   const lifecycle:any = []
    //   if(typeof result.assessed_state_backend == 'string'){
    //     lifecycle.push(result.assessed_state_backend)
    //   } else {
    //     if(result.assessed_state_backend[0] == 'NA'){
    //       lifecycle.push('None')
    //     }
    //   }
    // }

    //   this.existingQualifierValues[index] = allQualifier;

    //   return {
    //     ...result,
    //     sl_no: this.formatSerialNumber(index + 1),
    //     allQualifier,
    //     allMarketingChannels: marketingChannels,
    //     text_lifecycles:lifecycle[0],
    //     text_lifecycles_UI:lifecycleUI[0],
    //     richtext: false,
    //     isNewRow: false,
    //     isEdited: false,
    //     oldText: result.text,
    //     selected: true,
    //     isUpdated: false,
    //     back_translated_text: [],
    //     translated_text: [],
    //     translated_qualifier_text: [],
    //     claimOrder: (index + 1) * 10,
    //   };
    // });

    results = results.map((result, index) => {
      const allQualifier = [];

      // if(result.qualifier_veeva.length > 0){
      //   result.qualifier_veeva.forEach((res)=>{
      //     console.log('res',res)
      //     console.log('type of res',typeof res)
      if (result.qualifier_veeva != 'NA' && result.qualifier_veeva != null) {
        allQualifier.push({
          type: 'old',
          text: result.qualifier_veeva,
          icon: 'fa-robot',
        });
      }
      //   })
      // }

      // if (result.existing_qualifier.length > 0) {
      //   result.existing_qualifier.forEach((res) => {
      //     if (res != '<p></p>') {
      //       allQualifier.push({
      //         type: 'old',
      //         text: res,
      //         icon: 'fa-robot',
      //       });
      //     }
      //   });
      // }

      const qualifiers =
        resultsData?.qualifiers?.length > 0
          ? resultsData.qualifiers
          : sharedRouteData?.resultData?.qualifiers || [];

      qualifiers.forEach((res) => {
        allQualifier.push({
          type: 'new',
          text: res,
          icon: '',
        });
      });

      console.log('all qualifier', allQualifier);
      console.log('page from', this.pageFrom);

      const marketingChannels: any = [];
      if (this.routeSource == 'Draft' && this.dataFromResult == true) {
        if (result?.allMarketingChannels) {
          marketingChannels.push(...result.allMarketingChannels);
        } else {
          // when user comes to ira from Draft
          const combined = [
            ...result.marketing_channels_veeva,
            ...result.new_marketing_channel,
          ];
          combined.forEach((channel) => {
            if (!marketingChannels.includes(channel)) {
              marketingChannels.push(channel);
            }
          });
        }
      } else if (this.dataFromResult == true) {
        if (result?.allMarketingChannels) {
          marketingChannels.push(...result.allMarketingChannels);
        } else {
          marketingChannels.push(...result.new_marketing_channel);
        }
      } else {
        if (
          sharedRouteData &&
          sharedRouteData.pageFrom == 'iraResult' &&
          resultsData == undefined
        ) {
          marketingChannels.push(...result.allMarketingChannels);
        } else if (result && result?.allMarketingChannels && !sharedRouteData) {
          marketingChannels.push(...result.new_marketing_channel);
        } else {
          const combined = [
            ...(Array.isArray(result.marketing_channel)
              ? result.marketing_channel
              : []),
            ...(Array.isArray(result.new_marketing_channel)
              ? result.new_marketing_channel
              : []),
            ...(Array.isArray(result.marketing_channels_veeva)
              ? result.marketing_channels_veeva
              : []),
          ];

          combined.forEach((channel) => {
            if (!marketingChannels.includes(channel)) {
              marketingChannels.push(channel);
            }
          });
        }
      }

      console.log('marketing channels', marketingChannels);
      this.existingQualifierValues[index] = allQualifier;

      const baseResult = {
        ...result,
        sl_no: this.formatSerialNumber(index + 1),
        allQualifier,
        allMarketingChannels: marketingChannels,
        richtext: false,
        isNewRow: false,
        isEdited: false,
        oldText: result.text,
        selected: this.routeSource == 'Draft' ? result.selected : true,
        isUpdated: false,
        back_translated_text: [],
        translated_text: [],
        translated_qualifier_text: [],
        claimOrder: (index + 1) * 10,
      };

      // Add lifecycle fields only if this.dataFromPreview has a value
      if (this.pageFromPreview === 'preview') {
        const lifecycleUI: any = [];
        if (typeof result.assessed_state === 'string') {
          lifecycleUI.push(result.assessed_state);
        } else if (result.assessed_state[0] === 'NA') {
          lifecycleUI.push('None');
        }

        const lifecycle: any = [];
        if (typeof result.assessed_state_backend === 'string') {
          lifecycle.push(result.assessed_state_backend);
        } else if (result.assessed_state_backend[0] === 'NA') {
          lifecycle.push('None');
        }

        return {
          ...baseResult,
          text_lifecycles: lifecycle[0],
          text_lifecycles_UI: lifecycleUI[0],
        };
      }

      return baseResult;
    });

    console.log('results end', results);

    // Filter and update reasons and reason_model
    results.forEach((value) => {
      const count = value.reason.filter((v) => v == '0').length;
      value.reason = value.reason.filter((v) => v != '0');
      for (let k = 0; k < value.reason.length; k++) {
        if (
          value.reason_keywords.length == 0 &&
          value.reason.length != value.reason_model.length
        ) {
          value.reason_model = value.reason_model.slice(0, -count);
        }
      }
    });

    if (this.originalReport == undefined) {
      this.originalReport = sharedRouteData;
    }

    this.originalReport.results = results;
    console.log('original reports', this.originalReport);
    this.originalReport.total = this.getTotal(results);
    this.editableReport = _.cloneDeepWith(this.originalReport);
    console.log('editBLE reports', this.editableReport);
    this.dataSource.data = this.editableReport.results;
    console.log('data source data', this.dataSource.data);

    // Select all rows by default
    this.dataSource.data.forEach((row) => {
      if (row.selected == true) {
        this.selection.select(row);
      }
    });

    if (this.pageFromPreview == 'preview') {
      localStorage.removeItem('routeFrom');
    }
  }
  @Output() iraButtonEnable = new EventEmitter<void>();
  enableIraButton() {
    console.log('enable ira button called');
    this.iraButtonEnable.emit();
  }
  ngOnInit() {
    console.log('isResultPage', this.isResultPage);
    console.log('rowVisibleIra', this.rowVisibleIra);
    console.log('activeClaimsCount', this.activeClaimsCount > 0);
    this.enableIraButton();
    console.log('isEditClaimsRoute', this.isEditClaimsRoute);
    console.log('router from', this.routeFrom);
    console.log('geographyData', this.geographyDataLA);
    const sharedData = this.sharedService.getRouteData();
    this.eeocDocId = localStorage.getItem('docId');
    console.log('doc id', this.eeocDocId);
    console.log('type of doc id', typeof this.eeocDocId);
    console.log('sharedData', sharedData);
    // if (this.routeSource == 'Draft') {
    //
    // }

    //this.ResultComponent.makeIraTrue();
    if (
      sharedData &&
      sharedData.pageFrom == 'iraResult' &&
      this.dataFromResult == true
    ) {
      this.originalReport = sharedData.resultData;
      this.fileDetails = sharedData.fileDetails;
      this.pageFromPreview = this.dataFromResult == true ? '' : 'preview';
      this.fileBase64data = sharedData.resultData.fileBase64;
      this.previewMarketingChannels = sharedData.marketingChannels;
    }

    console.log('pagefrom', this.pageFromPreview);
    console.log('hideheader', this.hideHeader);
    this.sharedService.setIraResetFunction(() => this.resetAll());
    this.sharedService.setIraFormatQualifierFunction(() =>
      this.formatQualifier()
    );
    this.sharedService.setIraSaveAssetFunction(() =>
      this.populateOverallResult()
    );

    this.sharedService.setIraExportExcelFunction(() => this.exportExcel());

    this.sharedService.setIraExportPdfFunction(() => this.exportPdf());

    this.sharedService.setIraSaveasExcelFunction(() => this.saveasExcel());

    this.sharedService.setIraSaveasPdfFunction(() => this.saveasPDF());
    this.resultService.setSupportSubstantiationRedirect(false);

    console.log(this.dataFromResult);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.url === '/ira-confirmation') {
        this.loadingService.setLoading(false);
      }
    });

    // if (this.dataFromResult == 'fromResults') {
    console.log('data from page loading');
    console.log('iraaaaaaaaaaaaata', this.iraTableData);
    if (Array.isArray(this.iraTableData) && this.iraTableData.length === 2) {
      this.iraTableData.splice(0, 1);
    }
    console.log('ira data after splice', this.iraTableData);
    console.log('originalreportssssss', this.originalReport);
    if (this.dataFromResult == true) {
      // trigger save draft function after 30 seconds when change in input
      console.log('fileBlobData', this.fileBlobData);
      this.fileDetails = this.fileBlobData;
      this.autoSaveSubject
        .pipe(debounceTime(30000))
        .subscribe(() => this.saveDraftIra(this.fileDetails));

      let iraData: any;
      if (Array.isArray(this.iraTableData)) {
        iraData = this.iraTableData[0].iraresultsdata;
      } else {
        iraData = this.iraTableData;
      }

      // console.log('iraData', iraData);
      // iraData.results = iraData.results.filter((element: any) => {
      //   return element.Label?.trim().toLowerCase() == 'text';
      // });

      console.log('Filtered iraData:', iraData);

      this.originalReport = iraData;
      // Create a deep copy of iraData to avoid mutating the original object
      // this.originalReport = {
      // ...iraData,
      // results: iraData.results.filter((element: any) => {
      //   return element.Label?.trim().toLowerCase() == 'text';
      // }),
      // isFormatted: this.iraTableData[0].isFormatted,
      // };
      console.log('orig report data', this.originalReport);
      // Add 'checkbox' column if not already present
      if (!this.displayedColumns.includes('checkbox')) {
        this.displayedColumns = ['checkbox', ...this.displayedColumns];
      }

      this.resultsTableData(iraData);
      console.log('route source', this.routeSource);
      console.log('this.navigated from', this.navigatedFrom);
      //settings when result page with draft data with translation enabled
      if (this.routeSource == 'Draft') {
        if (this.navigatedFrom == 'home') {
          this.retakeAssessment();
        }
        let isTranslatedRow = this.dataSource.data.some((data) => {
          return data.translated_text.length > 0;
        });

        let isBackTranslatedRow = this.dataSource.data.some((data) => {
          return data.back_translated_text.length > 0;
        });

        if (isTranslatedRow) {
          if (this.navigatedFrom == 'home') {
            const dialogRef = this.dialog.open(IraAlertPopupComponent, {
              width: '370px',
              height: '190px',
              disableClose: true,
              data: {
                message:
                  'Since you are using your previously saved values, kindly perform translations again.',
                messageType: 'msgNotify',
              },
            });

            dialogRef.afterClosed().subscribe((confirm) => {
              if (confirm === true) {
                this.radioBtnValue = 'translation';
                this.selectedTranslationLanguage = localStorage.getItem(
                  'translationLanguage'
                );
                this.selectedLanguage = localStorage.getItem('language');
                const translationselected = { value: 'translation' };
                console.log('translationselected', translationselected);
                // this.toggle(translationselected);
                this.relatedStatementChecked = true;
                this.backtranslationChecked = false;
                this.showTranlsationGroup = true;
                this.showLanguageGroup = true;
                this.languageDisabled = false;
                this.defaultLanguageDisbaled = false;
                this.btnClicked = true;
                this.isRowVisible = true;
                this.onRelatedStatementClick();
              } else {
                this.router.navigate(['/home']);
              }
            });
          } else {
            this.radioBtnValue = 'translation';
            this.selectedTranslationLanguage = localStorage.getItem(
              'translationLanguage'
            );
            this.selectedLanguage = localStorage.getItem('language');
            const translationselected = { value: 'translation' };
            console.log('translationselected', translationselected);
            // this.toggle(translationselected);
            this.relatedStatementChecked = true;
            this.backtranslationChecked = false;
            this.showTranlsationGroup = true;
            this.showLanguageGroup = true;
            this.languageDisabled = false;
            this.defaultLanguageDisbaled = false;
            this.btnClicked = true;
            this.isRowVisible = true;
          }
        } else if (isBackTranslatedRow) {
          if (this.navigatedFrom == 'home') {
            const dialogRef = this.dialog.open(IraAlertPopupComponent, {
              width: '370px',
              height: '190px',
              disableClose: true,
              data: {
                message:
                  'Since you are using your previously saved values, kindly perform backtranslations again.',
                messageType: 'msgNotify',
              },
            });

            dialogRef.afterClosed().subscribe((confirm) => {
              console.log('confirm', confirm);
              if (confirm === true) {
                this.radioBtnValue = 'backtranslation';
                this.selectedTranslationLanguage = '';
                localStorage.removeItem('translationLanguage');
                this.relatedStatementChecked = false;
                this.backtranslationChecked = true;
                this.showTranlsationGroup = true;
                this.showLanguageGroup = true;
                this.languageDisabled = true;
                this.defaultLanguageDisbaled = true;
                // this.btnClicked = true;
                this.addColumn();
                this.getBackTranslationData();
              } else {
                this.router.navigate(['/home']);
              }
            });
          } else {
            this.radioBtnValue = 'backtranslation';
            this.selectedTranslationLanguage = '';
            localStorage.removeItem('translationLanguage');
            this.relatedStatementChecked = false;
            this.backtranslationChecked = true;
            this.showTranlsationGroup = true;
            this.showLanguageGroup = true;
            this.languageDisabled = true;
            this.defaultLanguageDisbaled = true;
            this.btnClicked = true;
            this.addColumn();
            //  this.getBackTranslationData();
          }
        } else {
          this.showTranlsationGroup = false;
        }
      }
    } else {
      // Remove 'checkbox' column if present
      this.displayedColumns = this.displayedColumns.filter(
        (col) => col !== 'checkbox'
      );

      this.resultsTableData(this.originalReport);
    }

    this.getMarketingChannels();

    console.log('tabledata', this.data);
    this.projectValue = localStorage.getItem('projectName');
    this.productValue = localStorage.getItem('productName');
    this.geographyValue = localStorage.getItem('geographyName');
    this.selectedLanguage = localStorage.getItem('language');
    // this.iraResultService.getTableData().subscribe((response: any) => {
    //   this.originalReport = response;
    //   this.dataSource.data = response.results.map((item: any) => ({
    //     ...item,
    //     originalText: item.text, // store original API value
    //   }));
    //   this.originalReport.total = this.getTotal(this.originalReport.results);
    // });

    // this.isReportEmpty = !this.editableReport.results.find(
    //   (value) => !value.isDeleted
    // );
    // this.dataSource.data = this.editableReport.results;
    this.dataSource.filterPredicate = this.createFilter();
    //   console.log(response);
    // });

    this.textFilter.valueChanges.subscribe((name) => {
      this.filterValues.text = name;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    });
    this.qualifierFilter.valueChanges.subscribe((name) => {
      this.filterValues.qualifier = name;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    });

    this.marketingFilter.valueChanges.subscribe((name: any) => {
      console.log(name, 'name applied');
      this.filterValues.marketing_channel = name;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    });
    this.geographyData = JSON.parse(
      localStorage.getItem('geographyDataValues') || ''
    );
    console.log('data from result', this.dataFromResult);

    const marketingChannels: any = [];
    this.dataSource.data.forEach((result) => {
      if (this.routeSource == 'Draft' && this.dataFromResult == true) {
        marketingChannels.push(...result.allMarketingChannels);
      } else {
        const combined = [
          ...result.marketing_channel,
          ...(Array.isArray(result.new_marketing_channel)
            ? result.new_marketing_channel
            : []),
        ];
        combined.forEach((channel) => {
          if (!marketingChannels.includes(channel)) {
            marketingChannels.push(channel);
          }
        });
      }
    });
    console.log('marketing channels', marketingChannels);

    this.dataSource.data = this.dataSource.data.map((item, index) => ({
      ...item,
      sl_no:
        this.dataFromResult == true
          ? this.formatSerialNumber(index + 1)
          : this.formatSerialNumber(item.sl_no),
      // allMarketingChannels: marketingChannels,
      originalText: item.text,
      text: item.text,
      isEdited: false,
      showIcons: false,
      // qualifiers:
      //   this.fileType == '' || this.originalReport?.qualifiers?.length > 0
      //     ? item?.existing_qualifier
      //       ? item?.existing_qualifier
      //       : item?.qualifiers
      //     : [],
      qualifiers: this.dataFromResult == true ? item.qualifiers : [],

      qualifiersFormControl: new FormControl(
        this.dataFromResult === true ? item.qualifiers ?? [] : []
      ),

      marketing_channel: item.marketing_channel || [],
      // claimOrder: (index + 1) * 10,
      translated_text: [],
      translated_qualifier_text: [],
      back_translated_text: [],
      selected_translated_text: item.selected_translated_text || [],
      selected_translated_qualifier_text: [],
      selected_back_translated_text: [],
    }));
    console.log('data source', this.dataSource.data);
    // for checkbox selction to selct all rows
    this.dataSource.data.forEach((row) => {
      if (row.selected == true) {
        this.selection.select(row);
      }
    });

    this.routeData = {
      fileDetails: this.fileDetails,
      docDetails: this.fileBase64data,
      marketingChannels: marketingChannels,
    };
    // this.originalReport.results = this.dataSource.data;
    // this.originalReport.total = this.getTotal(this.originalReport.results);
  }

  ngOnChanges() {
    console.log('isResultPage', this.isResultPage);
    console.log('rowVisibleIra', this.rowVisibleIra);
    console.log('activeClaimsCount', this.activeClaimsCount > 0);
  }

  // popup button when click on alert circle outline and opens new popup
  openLatestUpdatesPopup(rowData: any, index: number): void {
    const dialogRef = this.dialog.open(IraPopupComponent, {
      disableClose: true,
      width: '74em',
      height: '23em',
      data: {
        project: true,
        documentDetails: '',
        savedraftData: rowData, // Pass savedraft_data
        currentRowData: rowData.new_one, // Pass full row data
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('hhhhhhhh', result);
        if (result.removeAlert) {
          rowData.hideAlert = true; // Add a flag to hide the alert icon

          // } else {
          //   Object.assign(rowData, result); // Update with dummy data
        }
        if (result.action == 'decline') {
          this.dataSource.data[index] = result.savedInDraft; // Update with savedInDraft
          this.dataSource.data[index].allMarketingChannels =
            result.savedInDraft.allMarketingChannels;
          this.dataSource.data[index].text_lifecycles_UI =
            result.savedInDraft.text_lifecycles_UI; // life cycle

          this.dataSource.data[index].matched_status = 'matched'; // Update match status
        } else {
          this.dataSource.data[index].matched_status = 'matched'; // Update match status
          this.dataSource.data[index].sl_no = this.formatSerialNumber(
            index + 1
          );
          this.dataSource.data[index].qualifiers =
            result.updatedClaim.qualifier_veeva == 'NA'
              ? []
              : result.updatedClaim.qualifier_veeva;
          this.dataSource.data[index].allMarketingChannels =
            result.updatedClaim.marketing_channels_veeva == 'NA'
              ? []
              : result.updatedClaim.marketing_channels_veeva;
          this.dataSource.data[index].text_lifecycles_UI =
            result.updatedClaim.assessed_state; // life cycle
          this.dataSource.data[index].assessed_state =
            result.updatedClaim.assessed_state; // life cycle
          this.dataSource.data[index].assessed_state_backend =
            result.updatedClaim.assessed_state_backend; // life cycle back end name
          this.dataSource.data[index].Label = result.updatedClaim.Label; // Update with updatedClaim
          this.dataSource.data[index].level = result.updatedClaim.level; // Update with updatedClaim
          this.dataSource.data[index].level_keywords =
            result.updatedClaim.level_keywords; // Update with updatedClaim
          this.dataSource.data[index].level_model =
            result.updatedClaim.level_model;
          this.dataSource.data[index].manual_level =
            result.updatedClaim.manual_level;
          this.dataSource.data[index].risk = result.updatedClaim.risk;
          this.dataSource.data[index].risk_keywords =
            result.updatedClaim.risk_keywords;
          this.dataSource.data[index].risk_model =
            result.updatedClaim.risk_model;
          this.dataSource.data[index].manual_risk =
            result.updatedClaim.manual_risk;
          this.dataSource.data[index].reason = result.updatedClaim.reason;
          this.dataSource.data[index].reason_keywords =
            result.updatedClaim.reason_keywords;
          this.dataSource.data[index].manual_reason =
            result.updatedClaim.manual_reason;
          this.dataSource.data[index].reason_model =
            result.updatedClaim.reason_model;
          // updating editing permission fields
          this.dataSource.data[index].editing_status_manual_level =
            result.updatedClaim.editing_status_manual_level;
          this.dataSource.data[index].editing_status_manual_risk =
            result.updatedClaim.editing_status_manual_risk;
          this.dataSource.data[index].editing_status_mc =
            result.updatedClaim.editing_status_mc;
          this.dataSource.data[index].editing_status_qualifier =
            result.updatedClaim.editing_status_qualifier;
          this.dataSource.data[index].editing_status_statement =
            result.updatedClaim.editing_status_statement;
          this.dataSource.data[index].editing_status_reason =
            result.updatedClaim?.editing_status_reason;

          this.saveDraftIra(this.fileDetails);
        }
        if (result.updatedData) {
          Object.assign(rowData, result.updatedData);
        }

        this.selection.clear(); // Clear selection
        // Re-select rows based on the updated data
        this.dataSource.data.forEach((row) => {
          if (row.selected === true) {
            this.selection.select(row);
          }
        });
        console.log('data source', this.dataSource.data);
        //this.autoSaveSubject.next(); // Resets the timer
      }

      this.dataSource._updateChangeSubscription();
    });
  }

  //to get draft claims count
  get activeClaimsCount(): number {
    this.emitAnyRowEdited();
    return (
      this.dataSource?.data?.filter(
        (row) => row.matched_status == 'not matched'
      )?.length || 0
    );

  }

  // openLatestUpdatesPopup(element: any): void {
  //   const dialogRef = this.dialog.open(IraPopupComponent, {
  //     width: '700px',
  //     data: {
  //       rows: [
  //         {
  //           statementText: 'Pre-Calculations',
  //           qualifier: 'When using 18%/annum (annualized)',
  //           marketingChannel: 'Concept Claims',
  //           pageTab: '-',
  //           label: 'None',
  //           label2: '-',
  //         },
  //         {
  //           statementText: 'Pre-Calculations',
  //           qualifier: 'When using 18%/annum (annualized)',
  //           marketingChannel: 'Concept Claims',
  //           pageTab: '-',
  //           label: 'None',
  //           label2: '-',
  //         },
  //       ],
  //     },
  //   });

  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       console.log('User accepted the updates');
  //     }
  //   });
  // }

  wrapStatementandQualifiertext() {
    this.isTruncated = !this.isTruncated;

    // No need to modify the text content
    setTimeout(() => {
      const textareas = document.querySelectorAll(
        'textarea.txt-area-statement,textarea.txt-area-qualifier'
      );
      textareas.forEach((ta: any) => this.autoResize(ta));
    }, 0);
  }

  // autoResize(textarea: HTMLTextAreaElement) {
  //   if (!this.isTruncated) {
  //     textarea.style.height = 'auto';
  //     textarea.style.height = textarea.scrollHeight + 'px';
  //   } else {
  //     textarea.style.height = '40px';
  //   }
  autoResize(textarea: HTMLTextAreaElement) {
    if (!this.isTruncated) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
      textarea.style.overflow = 'hidden'; // Hide scrollbar
      textarea.style.resize = 'none'; // Prevent manual resizing
    } else {
      textarea.style.height = '40px';
      textarea.style.overflow = 'auto'; // Show scrollbar when truncated
      textarea.style.resize = 'none';
    }
  }

  @ViewChild('exportMenuTrigger') exportMenuTrigger!: MatMenuTrigger;
  @ViewChild('saveAsMenuTrigger') saveAsMenuTrigger!: MatMenuTrigger;

  openMenu(trigger: MatMenuTrigger, event: MouseEvent) {
    event.stopPropagation();
    trigger.openMenu();
  }

  // Logic for Bulk Entry
  onBulkEntry() {
    const dialogRef = this.dialog.open(IraAlertPopupComponent, {
      // width: '370px',
      // height: '190px',
      width: '28.7em',
      height: '14em',
      disableClose: true,
      data: {
        message:
          'Images will not be saved. Only text claims on this page will be visible on the next page for saving.',
        messageType: 'msgNotify',
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      console.log('data', data);
      console.log('original report', this.originalReport);
      console.log('data source', this.dataSource.data);
      if (data == true) {
        const claims_la = this.dataSource.data.filter((obj) => {
          delete obj.qualifiersFormControl;
          return obj;
        });

        // Construct a filtered version of originalReport
        const filteredOriginalReport = {
          coordinates: this.originalReport.coordinates,
          disclaimers: this.originalReport.disclaimers,
          fileBase64: this.fileBase64data,
          images: this.originalReport.images,
          metadata: this.originalReport.metadata,
          qualifiers: this.originalReport.qualifiers,
          results: claims_la,
          text: this.originalReport.text,
          timestamp: this.originalReport.timestamp,
          total: this.originalReport.total,
        };

        console.log('claims la', claims_la);

        // const fileBase64 = Array.isArray(this.originalReport?.fileBase64)
        //   ? this.originalReport.fileBase64[0]
        //   : this.originalReport?.fileBase64;

        this.resultsData.push({
          claims_la: claims_la,
          fileBase64: this.fileBase64data,
          new_qualifiers: this.originalReport.qualifiers,
          iRA_button_enable: true,
          new_marketing_channels: [],
          existing_qualifier: [],

          iraresultsdata: filteredOriginalReport, // Only Label=text entries
          isFormatted: this.isFormatted, //Add this line

          hideAlert: true,
        });

        console.log('ira results data', filteredOriginalReport);
        console.log('results data needed', this.resultsData);
        console.log('filedetails', this.fileDetails);
        console.log(
          'Filtered originalReport (only Label=text):',
          filteredOriginalReport
        );

        localStorage.setItem('routeFrom', 'ira');
        const pageFrom = 'iraResult';
        this.sharedService.setRouteData({
          resultData: this.resultsData[0].iraresultsdata,
          fileDetails: this.fileDetails,
          marketingChannels: this.previewMarketingChannels || [],
          pageFrom: pageFrom,
        });

        console.log('this.resultsdata', this.resultsData);
        this.pageFrom = 'ira';
        this.router.navigate(['/result'], {
          state: {
            data: this.resultsData,
            isExcel: false,
            fileDetails: this.fileDetails,
            pageFrom: this.pageFrom,
          },
        });
      }
    });
  }

  get total(): any {
    return this.editableReport?.results[this.editableReport?.total];
  }

  /**to get total level,risk,reason */
  private getTotal(results: any[]): number {
    console.log('results found', results);
    let maxResult;

    const max = results.reduce(function (prev, current) {
      if (+current.level > +prev.level) {
        if (+current.level == +prev.level) {
          if (+current.risk > +prev.risk) {
            return current;
          } else {
            return prev;
          }
        }
        return current;
      } else {
        if (+current.level == +prev.level) {
          if (+current.risk > +prev.risk) {
            return current;
          } else {
            return prev;
          }
        }
        return prev;
      }
    });

    maxResult = results.indexOf(max);

    if (maxResult === -1) {
      return maxResult;
    }
    let maxLevel = +results[maxResult].manual_level;
    let maxRisk = +results[maxResult].manual_risk;
    for (let i = maxResult + 1; i < results.length; i++) {
      if (results[i].isDeleted) {
        continue;
      }
      const level = +results[i].manual_level;
      const risk = +results[i].manual_risk;
      if (level > maxLevel) {
        maxResult = i;
        if (level === 3) {
          return maxResult;
        }
        maxLevel = level;
        maxRisk = risk;
        continue;
      }
      if (maxLevel === 2 && risk > maxRisk) {
        maxResult = i;
        maxLevel = level;
        maxRisk = risk;
      }
    }

    return maxResult;
  }

  //to load reason values
  get reasons(): string[] {
    return ClassificationResultValues.reason;
  }

  // To clear the statement text data in search bar
  clearSearch() {
    this.textFilter.setValue('');
  }

  // To clear the Qualifier search data in Search bar
  clearQualifierSearch() {
    this.qualifierFilter.setValue('');
  }

  // working as click and unclick for Statement Text search icon
  toggleStatementSearch() {
    this.showStatementSearch = !this.showStatementSearch;
    // if (!this.showSearchBox) {
    //   this.searchTerm = '';
    //   this.filteredElements = [...this.originalElements];
    // }
  }

  // Working as click and unclick for Marketing channel filter icon
  toggleMarketingFilter() {
    this.showMarketingFilter = !this.showMarketingFilter;
    if (this.showMarketingFilter) {
      // Wait for DOM to render before opening the select
      setTimeout(() => {
        this.marketingSelect?.open();
      }, 100);
    } else {
      // Clear the filter and close the select
      this.marketingChannelFilter.setValue([]);

      // Close the select if it's open
      setTimeout(() => {
        this.marketingSelect?.close();
      }, 100);
    }
    // if (!this.showMarketingFilter) {
    //   this.marketingChannelFilter.setValue([]);
    // }
  }

  // working as click and unclick for Qualifiier search icon
  toggleQualifierSearch() {
    this.showQualifierSearch = !this.showQualifierSearch;
    // if (!this.showSearchBox) {
    //   this.searchTerm = '';
    //   this.filteredElements = [...this.originalElements];
    // }
  }

  get resultReason(): any {
    return (
      this.editItem &&
      this.editItem.manual_reason &&
      this.editItem.manual_reason.map((item) => item)
    );
  }

  set resultReason(values: any[]) {
    if (this.editItem) {
      this.editItem.manual_reason = values.map<any>((value) => {
        return value;
      });
    }
  }

  isSomeSelected() {
    console.log(this.selection.selected);
    return this.selection.selected.length > 0;
  }

  // onTextInput(element: any): void {
  //   const current = element.text || '';
  //   const original = element.originalText || '';
  //   element.isEdited = current !== '' && current !== original;
  //   element.showIcons = element.isEdited;
  // }

  // clearText(element: any): void {
  //   element.text = element.originalText || '';
  //   element.showIcons = false;
  // }
  clearText(element: any): void {
    element.text = element.originalText || '';
    element.isEdited = false;
    element.showIcons = false;
  }
  onTextInput(element: any): void {
    const current = element.text || '';
    const original = element.originalText || '';
    const isEdited = current !== '' && current !== original;

    element.isEdited = isEdited;
    element.showIcons = isEdited;
  }

  /**to sanitize html elements */
  sanitizeHTML(content: string): SafeHtml {
    const div = document.createElement('div');
    if (content == undefined) {
      div.innerHTML = '';
    } else {
      div.innerHTML = content;
    }
    //div.innerHTML = content;
    // console.log('content', content);
    return div.textContent || div.innerText || '';
  }

  // truncate the qualifier column data and statement text column data
  truncateAllQualifiers() {
    this.isTruncated = !this.isTruncated;
    this.dataSource.data.forEach((element: any) => {
      if (this.isTruncated) {
        if (element.qualifiers.length > 25) {
          element.truncatedQualifier =
            element.qualifiers.substring(0, 30) + '...';
        } else {
          element.truncatedQualifier = element.qualifiers;
        }

        // Truncate text
        if (element.text.length > 25) {
          element.truncatedText = element.text.substring(0, 40) + '...';
        } else {
          element.truncatedText = element.text;
        }
      } else {
        // Revert
        element.truncatedQualifier = element.qualifiers;
        element.truncatedText = element.text;
      }
    });
  }

  /**to change manual level*/
  onLevelChanged(level: string, index) {
    console.log('level changed', level);
    console.log('editable report', this.editableReport);
    console.log('editable index', index);
    // Check if the level is a valid string and not empty
    this.autoSaveSubject.next(); // Resets the timer
    this.editableReport.results[index].manual_level = [level];
    this.dataSource.data[index].manual_level = [level];

    if (this.editItem == null || this.editIndex == null) {
      return;
    }
    // if (level === '2') {
    //   if (this.editableReport.results[index].level === '2') {
    //     this.editItem.risk = this.editableReport.results[index].risk;
    //   }
    // }
    console.log('editable report', this.editableReport);
  }

  /**to change manual risk */
  onRiskChanged(risk: string, index) {
    console.log('risk changed', risk);
    // let riskValue: string;
    // if (risk == '1') {
    //   riskValue = 'Low';
    // } else if (risk == '2') {
    //   riskValue = 'Medium';
    // } else if (risk == '3') {
    //   riskValue = 'High';
    // } else {
    //   riskValue = ' ';
    // }
    this.autoSaveSubject.next(); // Resets the timer
    this.editableReport.results[index].manual_risk = [risk];
    this.dataSource.data[index].manual_risk = [risk];
  }

  //to disable other option in reason other than selected
  onReasonChanged(reason: any[], index) {
    console.log('reason changed', reason);
    this.autoSaveSubject.next(); // Resets the timer
    this.editableReport.results[index].manual_reason = [...reason];
    console.log(
      'selected reason',
      this.editableReport.results[index].manual_reason
    );

    if (reason.length === 3) {
      // Disable all options except the selected ones

      this.disabledReasons = this.reasons.map((r) => !reason.includes(r));
    } else {
      // Enable all options
      this.disabledReasons = this.reasons.map(() => false);
    }
  }

  // Disable the options which is greater than 3 in Manual reason column
  isOptionDisabled(option: string, selectedReasons: string[]): boolean {
    if (selectedReasons.length === 3) {
      return !selectedReasons.includes(option);
    }
    return false;
  }

  // createFilter(): (data: any, filter: string) => boolean {
  //   let filterFunction = function (data, filter): boolean {
  //     console.log(data, 'data came');
  //     console.log(filter, 'filter came');

  //     let searchTerms = JSON.parse(filter);
  //     return (
  //       data.text.toLowerCase().indexOf(searchTerms.text) !== -1 &&
  //       data.qualifier
  //         .toString()
  //         .toLowerCase()
  //         .indexOf(searchTerms.qualifier) !== -1 &&
  //       data.new_marketing_channel.some((market) => {
  //         searchTerms.new_marketing_channel.includes(market);

  //       })

  //       // data.colour.toLowerCase().indexOf(searchTerms.colour) !== -1 &&
  //       // data.pet.toLowerCase().indexOf(searchTerms.pet) !== -1
  //     );
  //     // return data.text.toLowerCase().indexOf(searchTerms.text) !== -1;
  //   };
  //   return filterFunction;
  // }

  // Filtering part for statement and qualifier and marketing channel columns
  // createFilter(): (data: any, filter: string) => boolean {
  //   return function (data, filter): boolean {
  //     const searchTerms = JSON.parse(filter);
  //     console.log('data', data);
  //     const textMatch = data.text
  //       .toLowerCase()
  //       .includes(searchTerms.text.toLowerCase());
  //     const qualifierDataValue = data.qualifier.map((value) =>
  //       value.toLowerCase()
  //     );
  //     const qualifierMatch = qualifierDataValue.includes(
  //       searchTerms.qualifier.toLowerCase()
  //     );
  //     console.log('qualifier match', qualifierMatch);
  //     const marketingMatch =
  //       !searchTerms.new_marketing_channel.length ||
  //       searchTerms.new_marketing_channel.some((channel: string) =>
  //         data.new_marketing_channel.includes(channel)
  //       );

  //     return textMatch && qualifierMatch && marketingMatch;
  //   };
  // }

  // createFilter(): (data: any, filter: string) => boolean {
  //   let filterFunction = function (data, filter): boolean {
  //     console.log('data', data);
  //     let searchTerms = JSON.parse(filter);
  //     console.log('search term', searchTerms);
  //     const qualifierDataValue = data.qualifier.map((value) =>
  //       value.toLowerCase()
  //     );
  //     // const qualifierMatch = qualifierDataValue.includes(
  //     //   searchTerms.qualifier.toLowerCase()
  //     // );
  //     const marketingMatch =
  //       searchTerms.new_marketing_channel.length &&
  //       searchTerms.new_marketing_channel.some((channel: string) =>
  //         data.new_marketing_channel.includes(channel)
  //       );
  //     console.log('marketing match', marketingMatch);
  //     return (
  //       data.text.toLowerCase().indexOf(searchTerms.text) !== -1 &&
  //       data.qualifier
  //         .toString()
  //         .toLowerCase()
  //         .indexOf(searchTerms.qualifier) !== -1 &&
  //       marketingMatch
  //     );
  //   };
  //   return filterFunction;
  // }

  // createFilter(): (data: any, filter: string) => boolean {
  //   return function (data, filter): boolean {
  //     // Parse the filter string safely
  //     let searchTerms: {
  //       text?: string;
  //       qualifier?: string;
  //       new_marketing_channel?: string[];
  //     };

  //     try {
  //       searchTerms = JSON.parse(filter || '{}');
  //     } catch (e) {
  //       console.error('Invalid filter JSON:', filter);
  //       return true; // fallback to showing all data
  //     }

  //     // Normalize values for comparison
  //     const textSearch = (searchTerms.text || '').toLowerCase().trim();
  //     const qualifierSearch = (searchTerms.qualifier || '')
  //       .toLowerCase()
  //       .trim();
  //     const marketingChannels = Array.isArray(searchTerms.new_marketing_channel)
  //       ? searchTerms.new_marketing_channel
  //       : [];

  //     // Perform matching
  //     const textMatch = data.text?.toLowerCase().includes(textSearch);
  //     const qualifierMatch = data.qualifier
  //       ?.toString()
  //       .toLowerCase()
  //       .includes(qualifierSearch);
  //     const marketingMatch = marketingChannels.length
  //       ? marketingChannels.some((channel: string) =>
  //           data.new_marketing_channel?.includes(channel)
  //         )
  //       : true;

  //     return textMatch && qualifierMatch && marketingMatch;
  //   };
  // }

  createFilter(): (data: any, filter: string) => boolean {
    return function (data, filter): boolean {
      // Define the expected structure of the filter
      let searchTerms: {
        text?: string;
        qualifier?: string;
        marketing_channel?: string[];
      } = {};

      // Safely parse the filter string
      try {
        searchTerms = JSON.parse(filter || '{}');
      } catch (e) {
        console.error('Invalid filter JSON:', filter);
        return true; // fallback to showing all data
      }

      // Normalize values for comparison
      const textSearch = (searchTerms.text || '').toLowerCase().trim();
      const qualifierSearch = (searchTerms.qualifier || '')
        .toLowerCase()
        .trim();
      const marketingChannels = Array.isArray(searchTerms.marketing_channel)
        ? searchTerms.marketing_channel
        : [];

      // Normalize data fields
      const dataText = (data.text || '').toLowerCase();
      const dataQualifier = (data.qualifier || '').toString().toLowerCase();
      const dataMarketingChannels = Array.isArray(data.allMarketingChannels)
        ? data.allMarketingChannels
        : [];

      // Perform matching
      const textMatch = data.text
        .toLowerCase()
        .includes(searchTerms.text?.toLowerCase() || '');
      // const textMatch = textSearch === '' || dataText.includes(textSearch);
      // const qualifierMatch =
      //   qualifierSearch === '' || dataQualifier.includes(qualifierSearch);
      const qualifierMatch = data.qualifiers
        .toString()
        .toLowerCase()
        .includes(searchTerms.qualifier?.toLowerCase() || '');
      const marketingMatch =
        marketingChannels.length === 0 ||
        marketingChannels.some((channel: string) =>
          dataMarketingChannels.includes(channel)
        );

      // Debug logs
      console.log('Filter terms:', searchTerms);
      console.log('Data:', data);
      console.log('Matches:', { textMatch, qualifierMatch, marketingMatch });

      return textMatch && qualifierMatch && marketingMatch;
    };
  }

  // get isSelectedChanged(): boolean {
  //   if (this.editIndex >= 0 && this.editItem) {
  //     const manualTag =
  //       this.editItem.manual_level.manualTag ||
  //       this.editItem.manual_risk.manualTag ||
  //       this.editItem.manual_reason.find(
  //         (reason) => reason.manualTag
  //       );
  //     return !!manualTag;
  //   } else {
  //     return false;
  //   }
  // }

  // get isAnyRowChanged(): boolean {
  //   return this.isReportChanged || this.isSelectedChanged;
  // }

  selectDisclaimer(index: number) {
    if (!this.canEdit || index === this.disclaimerIndex) {
      return;
    }
    this.disclaimerIndex = index;
  }

  isDisclaimerSelected(index: number) {
    return this.disclaimerIndex === index;
  }

  get canEdit(): boolean {
    return true;
  }

  /**to get updated text */
  editableText(event: any, index: number) {
    if (
      this.dataSource.data[index].oldText != this.dataSource.data[index].text
    ) {
      this.dataSource.data[index].isEdited = true;
      this.autoSaveSubject.next(); // Resets the timer
      this.dataSource.data[index].isUpdated = true;
    } else {
      this.dataSource.data[index].isEdited = false;
      this.dataSource.data[index].isUpdated = false;
    }

    if (event.target.value != null || event.target.value != '') {
      this.isTextEditor[index] = true;
    } else {
      this.isTextEditor[index] = false;
    }

    const newText = event.target.value;
    const originalText =
      this.dataSource.data[index].oldText || this.dataSource.data[index].text; // Store original text if not already stored

    if (!this.dataSource.data[index].oldText) {
      this.dataSource.data[index].oldText = this.dataSource.data[index].text;
    } // Check if text is modified

    this.dataSource.data[index].isEdited = newText !== originalText; // Enable button if any row is edited
    console.log('this datasource', this.dataSource.data);
    this.emitAnyRowEdited();
    this.selection.clear();
    this.dataSource.data.forEach((row, index) => {
      if (row.selected == true) {
        this.selection.select(row);
      }
    });
    console.log('selcetion table', this.selection.selected);

    this.isTextModified = this.selection.selected.some(
      (row) => row.isEdited === true
    );
  }

  // /**to get global qualifiers and marketing channels for newly added claim/la*/
  getGlobalQualifiersMarketingChannels(event, index) {
    this.enableDropdowns = true;
    // this.selectedLanguage=localStorage.getItem('language');
    this.selectedLanguage = 'English';
    const defaultMarketingChannel =
      this.dataSource.data[0].new_marketing_channel;
    console.log('thisdatasource for global', this.dataSource);

    const newQualifiers = this.dataSource.data[index].qualifiers;
    const statementText = this.dataSource.data[index].text;

    //Global duplicate check through API
    let tableData = [...this.dataSource.data];
    const statements: any = [];
    const statementLanguage: any = [];
    tableData.forEach((element) => {
      if (element.text !== 'NULL') {
        statements.push(element.text.trim());
        statementLanguage.push(this.selectedLanguage);
      }
    });
    let newRowText: any;
    const duplicateCheckData = {
      text: statements,
      input_language: statementLanguage,
      session_id: sessionStorage.getItem('sessionId'),
      environment: localStorage.getItem('environment'),
    };
    this.sharedService
      .checkDuplicatesData(duplicateCheckData)
      .subscribe((res: any) => {
        this.loadingService.setLoading(true);
        if (res.duplicates.length > 0) {
          this.dataSource.data[index].selected = false; // to make deleted row's selected attribute to false
          this.dataSource.data.splice(index, 1); //to remove newly added row if found duplicate
          this.selection.selected.splice(index, 1); //to remove newly added row if found duplicate from selection array
          this.dataSource._updateChangeSubscription(); // to update datasource after removing row
          // this.dataSource.data = [...this.dataSource.data];
          // const finaltext =
          //   `Duplicate texts found.` +
          //   `${'<br><br>'}` +
          //   `'${res.duplicates.join(', ')}'`;

          // const dialogConfig = new MatDialogConfig();
          // dialogConfig.disableClose = true;
          // (dialogConfig.height = '35%'),
          //   (dialogConfig.width = '370px'),
          //   (dialogConfig.data = {
          //     message:
          //       finaltext + `${'<br><br>'}` + 'Please add the row again.',
          //     buttons: [{ id: 'OK', text: 'OK' }],
          //     messageType: 'duplicateVeeva',
          //     submitButtonId: 'OK',
          //     type: PopupType.ERROR,
          //   } as any);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          // (dialogConfig.height = '35%'),
          //   (dialogConfig.width = '370px'),
          (dialogConfig.height = '14em'),
            (dialogConfig.width = '28.7em'),
            (dialogConfig.data = {
              messageLines: [
                `The Claim/LA <b>'${res.duplicates.join(
                  '<br>'
                )}'</b> is already present on this page. <br> Kindly add a new row again.`,
              ],
              messageType: 'duplicateVeeva',
              buttons: [{ id: 'OK', text: 'OK' }],
              submitButtonId: 'OK',
              type: PopupType.ERROR,
            } as any);

          this.dialog
            .open(IraAlertPopupComponent, dialogConfig)
            .afterClosed()
            .subscribe((response) => {});
          this.loadingService.setLoading(false);
          return;
        } else {
          //if no duplicates found, then check whether statement is present Veeva library through API
          const checkExistingData = {
            text: statements,
            input_language: statementLanguage,
            session_id: sessionStorage.getItem('sessionId'),
            environment: localStorage.getItem('environment'),
          };
          this.sharedService
            .checkExistingVeevaData(checkExistingData)
            .subscribe((res: any) => {
              if (res.result.length > 0) {
                const textMessageData = res.result.map((text) => {
                  const finaltext = `"${text.new}" will be replaced with "${text.existing}" `;
                  return finaltext;
                });
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                // (dialogConfig.height = '35%'),
                //   (dialogConfig.width = '370px'),
                (dialogConfig.height = '14em'),
                  (dialogConfig.width = '28.7em'),
                  (dialogConfig.data = {
                    headerText: `The below statements are already present in the system. Hence, the existing values will be taken forward to the next page`,

                    message: `${textMessageData.join('<br>')}`,

                    buttons: [{ id: 'OK', text: 'Ok' }],
                    submitButtonId: 'OK',
                    messageType: 'duplicateVeeva',
                    type: PopupType.ERROR,
                  } as any);
                //   this.dialog
                //     .open(IraAlertPopupComponent, dialogConfig)
                //     .afterClosed()
                //     .subscribe((response) => {
                //       this.dataSource.data[index].text = res.result[0].existing;
                //     });
                //   newRowText = res.result[0].existing;
                //   this.loadingService.setLoading(false);
                // } else {
                //   newRowText = statementText;
                // }

                this.dialog
                  .open(IraAlertPopupComponent, dialogConfig)
                  .afterClosed()
                  .subscribe((response) => {
                    res.result.forEach((resItem) => {
                      const localIndex = this.dataSource.data.findIndex(
                        (arrItem) => arrItem.text === resItem.new
                      );
                      if (localIndex !== -1) {
                        this.dataSource.data[localIndex].text =
                          resItem.existing;
                      } else {
                        newRowText = resItem.existing;
                      }
                    });
                  });
                newRowText = newRowText || statementText;
                this.loadingService.setLoading(false);
              } else {
                newRowText = statementText;
              }

              //Check Global Marketing Channel and Qualifier
              let allQualifier: any = [];
              const data = {
                session_id: sessionStorage.getItem('sessionId'),
                text: newRowText,
                text_language: this.selectedLanguage,
                environment: localStorage.getItem('environment'),
                project_id: localStorage.getItem('projectId'),
                product_id:
                  localStorage.getItem('product') || 'V1800000000G021',
                geography_id: localStorage.getItem('geography'),
                user_security_profile:
                  localStorage.getItem('userRole') || 'claims_lead__c',
                project_access: JSON.parse(
                  localStorage.getItem('projectAccessDetails') || ''
                ),
                business_group:
                  localStorage.getItem('businessGroup') || 'home_care__c',
                user_id: localStorage.getItem('userId') || 22487846,
                page: 'ira',
                countries: [localStorage.getItem('geographyName')],
                product_format: localStorage.getItem('productFormat'),
                application: 'EEOC',
                doc_id: localStorage.getItem('docId'),
              };
              const qualifierArr: any = [];

              this.iraResultService
                .checkGlobalClaimLA(data)
                .subscribe((response: any) => {
                  this.loadingService.setLoading(true);
                  //to set editing status for newly added row
                  // this.dataSource.data[index].editing_status.claim_order__c =
                  //   response.editing_status.claim_order__c;
                  // this.dataSource.data[
                  //   index
                  // ].editing_status.marketing_channels__c =
                  //   response.editing_status.marketing_channels__c;
                  // this.dataSource.data[index].editing_status.qualifier__c =
                  //   response.editing_status.qualifier__c;
                  // this.dataSource.data[index].editing_status.statement_text__v =
                  //   response.editing_status.statement_text__v;
                  this.dataSource.data[index].matched_status = 'matched';
                  this.dataSource.data[index].isFieldsDisabled = false;
                  this.dataSource.data[index].isEdited = false;
                  this.emitAnyRowEdited();
                  this.dataSource.data[index].marketing_channel = [];

                  if (response.global_claims_result.Qualifier_UI.length > 0) {
                    response.global_claims_result.Qualifier_UI.map((result) => {
                      if (result != '<p></p>') {
                        allQualifier.push(result);
                        // this.dataSource.data[index].existing_qualifier.push(result)
                      }
                    });
                  }
                  if (this.isFormatted == false) {
                    if (
                      this.dataSource.data[index].existing_qualifier.length > 0
                    ) {
                      this.originalReport.qualifiers.map((result) => {
                        allQualifier.push(result);
                      });
                    } else {
                      this.dataSource.data[index].existing_qualifier =
                        allQualifier;
                      this.dataSource.data[index].qualifiers = allQualifier;
                      this.dataSource.data[index].qualifier_veeva =
                        allQualifier;
                    }
                  }

                  // this.selectedQualifiers[index] = allQualifier;
                  this.dataSource.data[index].existing_qualifier = allQualifier;
                  this.dataSource.data[index].qualifier_veeva = allQualifier;
                  this.dataSource.data[index].allQualifier = allQualifier;
                  this.existingQualifierValues.splice(
                    this.existingQualifierValues.length + 1,
                    0,
                    allQualifier
                  );

                  if (this.isFormatted == true) {
                    if (allQualifier.length > 0) {
                      this.dataSource.data[index].qualifiers = [
                        allQualifier[0],
                      ];
                      this.dataSource.data[index].existing_qualifier = [
                        allQualifier[0],
                      ];
                    } else {
                      this.dataSource.data[index].qualifiers = [];
                    }
                  }
                  if (
                    response.global_claims_result.marketing_channel.length > 0
                  ) {
                    this.dataSource.data[index].marketing_channel = [
                      ...response.global_claims_result.marketing_channel,
                    ];
                    this.dataSource.data[index].allMarketingChannels = [
                      ...response.global_claims_result.marketing_channel,
                    ];
                    this.dataSource.data[index].marketing_channels_veeva = [
                      ...response.global_claims_result.marketing_channel,
                    ];
                  } else {
                    this.dataSource.data[index].marketing_channel = [];
                    this.dataSource.data[index].allMarketingChannels = [];
                  }

                  if (response.global_claims_result.lifecycle.length > 0) {
                    this.dataSource.data[index].assessed_state =
                      response.global_claims_result.lifecycle_UI[0];
                    this.dataSource.data[index].text_lifecycles_UI =
                      response.global_claims_result.lifecycle_UI[0];
                    this.dataSource.data[index].assessed_state_backend =
                      response.global_claims_result.lifecycle[0];
                    this.dataSource.data[index].text_lifecycles =
                      response.global_claims_result.lifecycle[0];
                  } else {
                    this.dataSource.data[index].assessed_state = '';
                    this.dataSource.data[index].assessed_state_backend = 'None';
                    this.dataSource.data[index].text_lifecycles_UI = 'None';
                    this.dataSource.data[index].text_lifecycles = 'None';
                  }

                  this.dataSource.data[index].editing_status_qualifier =
                    response.global_claims_result.editing_status.qualifier__c;
                  this.dataSource.data[index].editing_status_mc =
                    response.global_claims_result.editing_status.marketing_channels__c;
                  this.dataSource.data[index].editing_status_statement =
                    response.global_claims_result.editing_status.statement_text__v;

                  this.loadingService.setLoading(false);
                  const classifiedResult =
                    response.classified_image_result?.results?.[0];
                  console.log('classifiedResult', classifiedResult);
                  console.log('datasource', this.dataSource.data);
                  if (classifiedResult) {
                    this.dataSource.data[index].level =
                      classifiedResult.level || [];
                    this.dataSource.data[index].level_model =
                      classifiedResult.level_model || [];
                    this.dataSource.data[index].manual_level =
                      classifiedResult.manual_level || [];

                    this.dataSource.data[index].risk =
                      classifiedResult.risk || [];
                    this.dataSource.data[index].risk_model =
                      classifiedResult.risk_model || [];
                    this.dataSource.data[index].manual_risk =
                      classifiedResult.manual_risk || [];

                    this.dataSource.data[index].reason =
                      classifiedResult.reason || [];
                    this.dataSource.data[index].reason_model =
                      classifiedResult.reason_model || [];
                    this.dataSource.data[index].manual_reason =
                      classifiedResult.manual_reason || [];
                  }
                });
            });
        }
      });
    // new added line for after click content save outline enable proceed button

    this.dataSource.data[index].isSaveCompleted = true;
    this.checkIfProceedShouldBeEnabled();
  }
  checkIfProceedShouldBeEnabled() {
    this.isTextModified = this.dataSource.data.some(
      (row) => row.isEdited && !row.isSaveCompleted
    );

    const test = this.dataSource?.data?.some(
      (element: any) =>
        (element.isFieldsDisabled || element.isEdited) &&
        (element.isNewRow || element.isEdited)
    );

    const test1 = this.dataSource?.data?.some(
      (element: any) => element.isEdited
    );
    console.log('test value', test);
    console.log('test value', test1);
  }

  /**to save overall result data to veeva  */
  populateOverallResult() {
    this.loadingService.setLoading(true);

    let totalRisk;
    if (this.total.risk == '1') {
      totalRisk = 'low';
    } else if (this.total.risk == '2') {
      totalRisk = 'medium';
    } else if (this.total.risk == '3') {
      totalRisk = 'high';
    } else {
      totalRisk = this.total.risk;
    }
    const data = {
      session_id: sessionStorage.getItem('sessionId'),
      doc_id: localStorage.getItem('docId'),
      product__c: localStorage.getItem('product'),
      geography__c: localStorage.getItem('geography'),
      risk_level__c: totalRisk,
      classification__c: this.total.level.toString(),
      reasons__c: this.total.reason,
      environment: localStorage.getItem('environment'),
    };

    this.iraResultService
      .populateOverallResult(data)
      .subscribe((response: any) => {
        if (
          response.data[0].responseStatus == 'SUCCESS' ||
          response.responseStatus == 'WARNING'
        ) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          // (dialogConfig.height = '35%'),
          //   (dialogConfig.width = '370px'),
          (dialogConfig.height = '14em'),
            (dialogConfig.width = '28.7em'),
            (dialogConfig.data = {
              message:
                'Asset Risk Value successfully saved in Veeva. Check Asset Risk Assessments in the asset document in Veeva for the record.',

              buttons: [{ id: 'SAVE', text: 'OK' }],
              submitButtonId: 'SAVE',
              messageType: 'ira-alert',
              type: PopupType.INFO,
            } as any);
          this.dialog.open(IraAlertPopupComponent, dialogConfig);
          // return;
        } else if (response.data[0].responseStatus == 'FAILURE') {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          // (dialogConfig.height = '35%'),
          //   (dialogConfig.width = '370px'),
          (dialogConfig.height = '14em'),
            (dialogConfig.width = '28.7em'),
            (dialogConfig.data = {
              message: `Asset Risk Value failed to save in Veeva.

Please try the action again. If the issue still persists, kindly contact your Vault administrator.`,

              buttons: [{ id: 'SAVE', text: 'OK' }],
              submitButtonId: 'SAVE',
              messageType: 'ira-alert',
              type: PopupType.ERROR,
            } as any);
          this.dialog.open(IraAlertPopupComponent, dialogConfig);
          // return;
        }
        this.loadingService.setLoading(false);
      });
  }

  /**to export as Excel */
  exportExcel() {
    this.editRow(null, null);
    this.verifyReport().then((value) => {
      if (value) {
        this.loadingService.setLoading(true);
        const report = this.clearReport();
        console.log('reports getting', report);

        this.excelService
          .exportReport(report)
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.loadingService.setLoading(false);
          });
      }
    });
  }

  /**to export as PDF */
  exportPdf() {
    this.editRow(null, null);
    this.loadingService.setLoading(true);
    setTimeout(() => {
      this.verifyReport().then((value) => {
        if (value) {
          const report = this.clearReport();
          console.log('report', report);
          this.pdfService
            .saveReport(report)
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.loadingService.setLoading(false);
              // this.uploadReport(report);
            });
        }
      });
    }, 0);
  }

  /**to save document as PDF to veeva */
  async saveasPDF() {
    this.loadingService.setLoading(true);
    const report = this.clearReport();
    const pdf: any = await this.pdfService.getReportFile(report);
    const pdfData: any = await Converters.toBase64(pdf);

    this.iraResultService.saveAsPDF(pdfData).subscribe((response: any) => {
      if (response.responseStatus == 'SUCCESS') {
        const dialogConfig = new MatDialogConfig();
        // (dialogConfig.height = '35%'),
        //   (dialogConfig.width = '370px'),
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.disableClose = true);
        dialogConfig.data = {
          message: `Risk Report Document successfully saved in Veeva. Check Risk Assessment Reports in the asset document in Veeva for the report.`,

          buttons: [{ id: 'SAVE', text: 'OK' }],
          submitButtonId: 'OK',
          messageType: 'ira-alert',
          type: PopupType.INFO,
        } as any;
        this.dialog.open(IraAlertPopupComponent, dialogConfig).afterClosed();
      } else if (response.responseStatus == 'FAILURE') {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // (dialogConfig.height = '35%'),
        //   (dialogConfig.width = '370px'),
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Risk Report Document failed to save in Veeva.

Please try the action again. If the issue still persists, kindly contact your Vault administrator.`,

            buttons: [{ id: 'SAVE', text: 'OK' }],
            submitButtonId: 'OK',
            messageType: 'ira-alert',
            type: PopupType.ERROR,
          } as any);
        this.dialog.open(IraAlertPopupComponent, dialogConfig).afterClosed();
      }
      this.loadingService.setLoading(false);
    });
  }

  /**to save document as excel to veeva */
  async saveasExcel() {
    this.loadingService.setLoading(true);
    const report = this.clearReport();
    const excel = await this.excelService.getReportFile(report);
    const excelData: any = await Converters.toBase64(excel);
    this.iraResultService.saveAsExcel(excelData).subscribe((response: any) => {
      if (response.responseStatus == 'SUCCESS') {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // (dialogConfig.height = '35%'),
        //   (dialogConfig.width = '370px'),
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Risk Report Document successfully saved in Veeva. Check Risk Assessment Reports in the asset document in Veeva for the report.`,

            buttons: [{ id: 'SAVE', text: 'OK' }],
            submitButtonId: 'OK',
            messageType: 'ira-alert',
            type: PopupType.INFO,
          } as any);
        this.dialog.open(IraAlertPopupComponent, dialogConfig).afterClosed();
      } else if (response.responseStatus == 'FAILURE') {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // (dialogConfig.height = '35%'),
        //   (dialogConfig.width = '370px'),
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Risk Report Document failed to save in Veeva.

Please try the action again. If the issue still persists, kindly contact your Vault administrator.`,

            buttons: [{ id: 'SAVE', text: 'OK' }],
            submitButtonId: 'OK',
            messageType: 'ira-alert',
            type: PopupType.ERROR,
          } as any);
        this.dialog.open(IraAlertPopupComponent, dialogConfig).afterClosed();
      }
      this.loadingService.setLoading(false);
    });
  }

  private uploadReport(report: ClassificationReport) {
    this.iraResultService.uploadReport(report).subscribe(() => {});
  }

  /**to edit the row */
  editRow(index: any, event?: any) {
    event?.stopPropagation();
    if (!this.canEdit || index === this.editIndex) {
      return;
    }
    this.updateResult();
    this.editIndex = index;
    this.editItem =
      index == null ? null : _.cloneDeep(this.editableReport.results[index]);
  }

  /**to update the result */
  updateResult() {
    if (this.editItem == null) {
      return;
    }
    const original: any = this.originalReport.results[this.editIndex];

    this.editItem = _.cloneDeep(this.editableReport.results[this.editIndex]);
    if (
      this.isDisclaimersChanged() ||
      this.isEdited(this.editItem, this.editIndex)
    ) {
      this.isReportChanged = true;
    } else {
      this.isReportChanged = !!this.editableReport.results.find(
        this.isEdited.bind(this)
      );
    }

    if (this.isReportChanged) {
      this.editableReport.total = this.getTotal(this.editableReport.results);
    } else {
      this.editableReport.total = this.originalReport.total;
    }

    if (_.isEqual(this.editItem, this.editableReport.results[this.editIndex])) {
      return;
    }

    this.editItem = null;
    this.editIndex = null;
    this.refreshReport();
  }

  private verifyReport(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (!this.canEdit) {
        resolve(true);
        return;
      }

      resolve(true);
    });
  }
  /**to get new reports */
  private refreshReport() {
    this.editableReport.results = [...this.editableReport.results];
    this.dataSource._updateChangeSubscription();
  }

  /**to clear reports */
  private clearReport(): any {
    const hasImageData = this.dataSource.data.some((row) => {
      return row.isEdited == true || row.isFieldsDisabled == true;
    });
    if (hasImageData) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      (dialogConfig.height = '14em'),
        (dialogConfig.width = '28.7em'),
        (dialogConfig.data = {
          headerText: `Please get the data for the edited statement text before proceeding further`,
          buttons: [{ id: 'OK', text: 'COMMON.OK' }],
          submitButtonId: 'OK',
          type: PopupType.ERROR,
          messageType: 'duplicateVeeva',
        } as any);
      this.dialog
        .open(IraAlertPopupComponent, dialogConfig)
        .afterClosed()
        .subscribe((response) => {});
      return;
    }

    this.editableReport.results = [...this.dataSource.data];
    const report = _.cloneDeep(this.editableReport);
    console.log('report', report);
    console.log('editable report', this.editableReport);
    if (!this.canEdit) {
      return report;
    }
    if (this.editableReport.results.find(this.isEdited.bind(this))) {
      report.timestamp = new Date().getTime();
    }
    report.total = this.editableReport.total;
    // for (
    //   let resultIndex = 0;
    //   resultIndex < report.results.length;
    //   resultIndex++
    // ) {
    //   const result = report.results[resultIndex];
    //   const edited = this.editableReport.results[resultIndex];
    //   console.log('edited', edited);
    //   if (edited.isDeleted) {
    //     // No need to adjust items marked as deleted
    //     if (this.editableReport.total > resultIndex) {
    //       report.total--;
    //     }
    //     continue;
    //   }

    //   if (edited.level.manualTag) {
    //     result.level.manualTag = edited.level.prediction;
    //   }
    //   if (edited.risk.manualTag) {
    //     result.risk.manualTag = edited.risk.prediction;
    //   }
    //   const reasonsCountDiff = edited.reason.length - result.reason.length;
    //   if (reasonsCountDiff > 0) {
    //     result.reason.concat(
    //       _.fill<ClassificationItem>(Array(reasonsCountDiff), {
    //         prediction: null,
    //       })
    //     );
    //   }

    //   const editDiff: ClassificationItem[] = edited.reason.filter((value) => {
    //     return !result.reason.find((originValue) => originValue === value);
    //   });
    //   const resultDiff: ClassificationItem[] = result.reason.filter((value) => {
    //     return !edited.reason.find((editedValue) => editedValue === value);
    //   });

    //   editDiff.forEach((editedValue) => {
    //     const originalValue = resultDiff.find((value) => !value.manualTag);
    //     if (originalValue) {
    //       originalValue.manualTag = editedValue.prediction;
    //     } else {
    //       result.reason.push({
    //         prediction: '',
    //         manualTag: editedValue,
    //       });
    //     }
    //   });

    //   // result.reason.forEach((reason) => {
    //   //   if (reason.manualTag || !reason.length) {
    //   //     return;
    //   //   }
    //   //   if (!edited.reason.find((editedValue) => editedValue === reason)) {
    //   //     reason.manualTag = Const.deletedReason;
    //   //     return;
    //   //   }
    //   //   if (edited.approvedReasons && edited.approvedReasons.includes(reason)) {
    //   //     reason.manualTag = reason;
    //   //   }
    //   // });
    // }

    for (let i = report.results.length - 1; i >= 0; i--) {
      if (this.editableReport.results[i]?.isDeleted) {
        report.results.splice(i, 1);
      }
    }

    report.metadata = {
      project: this.projectValue,
      product: this.productValue,
      geography: this.geographyValue,
      productFormat: localStorage.getItem('productFormat'),
    };
    console.log('editable report', this.editableReport);
    console.log('ori report', this.editableReport);
    report.disclaimers =
      _.clone(this.editableReport?.qualifiers) ||
      _.clone(this.originalReport?.disclaimers);
    console.log('report', report);
    return report;
  }

  /**to check if the row is edited or not */
  private isEdited(result: any, index: number): boolean {
    const original: any = this.dataSource.data[index];
    const isEdited = false;
    // const isEdited =
    //   result.manual_reason.prediction.find((value) => value.manualTag) ||
    //   result.manual_level.manualTag ||
    //   result.manual_risk.manualTag ||
    //   result.isDeleted;
    return !!isEdited || original.reason.length !== result.reason.length;
  }

  private compareOrigin(
    edited: any,
    original: ClassificationItem
  ): ClassificationItem {
    if (edited == original) {
      return original;
    } else {
      return { prediction: edited, manualTag: 'true' };
    }
  }

  private isDisclaimersChanged() {
    return (
      this.editableReport.disclaimers.length !==
      this.originalReport.disclaimers.length
    );
  }

  init: any;
  /**enable editor when user clicks on particular text area */

  enableEditor(event, index) {
    this.autoSaveSubject.next(); // Resets the timer
    this.dataSource.data.forEach((value, i) => {
      console.log('value', value);
      if (index === i) {
        value.richtext = true;
        this.init = {
          setup: (editor) => {
            editor.on('init', () => {
              this.updateEditorQualifierHeight(editor); // Call function to set height dynamically
              console.log('value?.qualifiers', value?.qualifiers);
              if (typeof value.qualifiers == 'string') {
                if (value?.qualifiers.length > 0) {
                  console.log('value?.qualifiers', value?.qualifiers);
                  editor.setContent(
                    value.qualifiers.toString().split(',').join('<br> ')
                  );
                } else {
                  // if (typeof value.qualifiers == 'object') {
                  //   editor.setContent(
                  //     value.qualifiers.toString().split(',').join('<br> ')
                  //   );
                  // } else {
                  console.log('in else');
                  const content = editor.getContent();
                  this.updateQualifiers(index, content);
                  // }
                }
              } else {
                editor.setContent(
                  value.qualifiers.toString().split(',').join('<br> ')
                );
              }
            });
            editor.on('change', () => {
              this.dataSource.data[index].isUpdated = true;
            });
            window.addEventListener('resize', () => {
              this.updateEditorQualifierHeight(editor); // Update height on window resize
            });
          },
          extended_valid_elements: 'b,i',
          formats: {
            bold: { inline: 'b' },
            italic: { inline: 'i' },
            underline: { inline: 'u' },
          },
          height: 100,
          branding: false,
          menubar: false,
          resize: false,
          statusbar: false,
          font_family_formats: 'Unilever Shilling = unilever shilling;',
          content_style:
            '@import url(https://db.onlinewebfonts.com/c/234d23830d4b4e8a08fdf491981b4b1f?family=Unilever+Shilling); body { font-size: 10px; color: #49526E; font-family: "Unilever Shilling";margin-left:5px;line-height:1.2;margin-top:-9px } @media (min-width: 2560px) { body { font-size: 25px; } } @media (min-width: 3840px) { body { font-size: 30px; } }',
          outputFormat: 'html',
          plugins: 'fullscreen',
          toolbar:
            'bold italic underline fullscreen  | formatselect | undo redo |\
     alignleft aligncenter alignright alignjustify | \
     bullist numlist outdent indent | removeformat  ',
        };
      } else if (index != i) {
        value.richtext = false;
      }
    });
  }

  // to display text editor from rich text editor when click outside of textarea box
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const clickedInsideEditor = (event.target as HTMLElement).closest('editor');
    const clickedInsideTextarea = (event.target as HTMLElement).closest(
      'textarea'
    );

    if (!clickedInsideEditor && !clickedInsideTextarea) {
      this.dataSource.data.forEach((value) => {
        value.richtext = false;
      });
    }
  }

  updateEditorQualifierHeight(editor) {
    const editorContainer = editor.getContainer();
    console.log('test');
    console.log('editorContainer', editorContainer);
    if (!editorContainer) {
      console.error('Editor container is undefined');
      return;
    }
    const width = window.innerWidth;

    // 150% @media screen and (max-width: 1280px)
    if (width <= 1280) {
      console.log('150% height');
      //editorContainer.style.height = '10vh';
      editorContainer.style.height = '3.9em';
      //  editorContainer.style.width = '45vw';
    }
    // 1366 × 768 resolution
    else if (width <= 1366) {
      console.log('1366 height');
      editorContainer.style.height = '3.9em';
      // editorContainer.style.width = '45vw';
    }
    // 125%
    else if (width <= 1536) {
      console.log('125% height');
      editorContainer.style.height = '3.9em';
      //editorContainer.style.width = '45vw';
    }
    // **Exclude 1920px screens before checking 2560px**
    else if (width > 1920 && width <= 2560) {
      console.log('1920 height');
      editorContainer.style.height = '4.2em';
      //editorContainer.style.width = '45vw';
    }
    // 3840+ resolution
    else if (width >= 3840) {
      console.log('3840 height');
      editorContainer.style.height = '4.2em';
      //editorContainer.style.width = '45vw';
    }
    // **Default case for 1920 × 1080** 100%
    else {
      console.log('100% height');
      editorContainer.style.height = '4.2em';
      //editorContainer.style.width = '46vw';
    }
  }
  /**update added qualifier */
  updateQualifiers(index, content) {
    const contentString = content.toString(); // Convert content to a string

    // Check if contentString is not empty
    if (contentString.trim() !== '') {
      const qualifiers = contentString
        .split('<br> ')
        .map((item) => item.trim());
      this.dataSource.data[index].qualifiers = qualifiers;
      this.selectedQualifiersUpdated[index] = qualifiers;
      this.enteredQualifiers[index] = qualifiers;
    }
  }

  retakeAssessment() {
    const dialogRef = this.dialog.open(IraAlertPopupComponent, {
      width: '370px',
      height: '190px',
      disableClose: true,
      data: {
        message:
          'Since you are using your previously saved values, kindly rerun risk assessment',
        messageType: 'msgNotify',
      },
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm === true) {
        console.log('table data', this.dataSource.data);
        this.loadingService.setLoading(true);
        // to remove qualifiers form control property from Result Array
        const selectedUpdatedArray = this.dataSource.data.filter((obj) => {
          delete obj.qualifiersFormControl;
          return obj;
        });

        // to add qualifiers inside array if its a string
        const finalTableData = selectedUpdatedArray.map((value) => {
          if (typeof value.qualifiers == 'string') {
            value.qualifiers = [value.qualifiers];
          }
          return value;
        });

        // to remove duplicate array object values and keep the latest values
        var selectedRows = finalTableData.reduce((unique, o) => {
          const existingIndex = unique.findIndex(
            (obj) => obj.sl_no === o.sl_no
          );
          if (existingIndex !== -1) {
            unique[existingIndex] = o; // update the existing object with the latest values
          } else {
            unique.push(o);
          }
          return unique;
        }, []);

        const result = finalTableData?.sort((a, b) => {
          if (
            typeof a.claim_order === 'string' &&
            typeof b.claim_order === 'string'
          ) {
            return a.claim_order.localeCompare(b.claim_order);
          } else {
            // Handle non-string values
            return a.claim_order - b.claim_order;
          }
        });
        // Check if any row has an empty text field
        const hasEmptyText: boolean = result.some(
          (row) => row.text == '' && row.selected == true
        );

        let textValues: any = [];
        let qualifiers: any = [];
        let relatedTranslations: any = [];
        let qualifierTranslations: any = [];
        let backTranslations: any = [];
        let oldMarketingChannelValues: any = [];
        let newMarketingChannelValues: any = [];
        let claimOrders: any = [];
        let lifeCycle: any = [];
        let lifeCycle_UI: any = [];
        let textExist: any = [];

        const tableData = result.filter((row) => {
          return row.selected == true;
        });
        tableData.filter((val: any) => {
          textValues.push(val.text);
          textExist.push(val.text_exist);
          claimOrders.push(val.claimOrder);

          //translation
          // if (val?.selected_translated_text.length > 0) {
          //   relatedTranslations.push(val.selected_translated_text);
          // } else {
          relatedTranslations.push([]);
          // }

          //qualifier translation
          // if (typeof val.selected_translated_qualifier_text == 'string') {
          //   qualifierTranslations.push([val.selected_translated_qualifier_text]);
          // } else {
          //   if (val.selected_translated_qualifier_text.length > 0) {
          //     qualifierTranslations.push(val.selected_translated_qualifier_text);
          //   } else {
          qualifierTranslations.push([]);
          //   }
          // }

          //back translation
          // if (val?.selected_back_translated_text.length > 0) {
          //   backTranslations.push(val.selected_back_translated_text);
          // } else {
          backTranslations.push([]);
          // }

          //qualifier
          if (typeof val.qualifiers == 'string') {
            val.qualifiers = [val.qualifiers];
            qualifiers.push(val.qualifiers);
          } else {
            if (val.qualifiers.length > 0) {
              val.qualifiers.map((qualifier) => {
                if (qualifier == undefined || qualifier == null) {
                  qualifiers.push([]);
                } else {
                  qualifiers.push(qualifier);
                }
              });
            } else {
              qualifiers.push([]);
            }
          }

          //existing marketing channel
          if (val?.new_marketing_channel.length > 0) {
            oldMarketingChannelValues.push(val.marketing_channel);
          } else {
            oldMarketingChannelValues.push([]);
          }

          //new marketing channel
          if (val?.allMarketingChannels.length > 0) {
            newMarketingChannelValues.push([
              ...new Set(val.new_marketing_channel),
            ]);
          } else {
            newMarketingChannelValues.push([]);
          }

          //text lifecycle
          // if (val.assessed_state_backend == '') {
          //   lifeCycle.push('None');
          // } else {
          lifeCycle.push(val.text_lifecycles);
          // }

          //text lifecycle UI
          // if (val.assessed_state == '') {
          //   lifeCycle_UI.push('None');
          // } else {
          lifeCycle_UI.push(val.text_lifecycles_UI);
          // }
        });

        const languageValue = localStorage.getItem('language');
        console.log('original report draft', this.originalReport);
        this.previewService
          .getiRAClassification(
            this.originalReport.fileBase64[0].document,
            this.globalMetadata,
            false,
            false,
            textValues,
            qualifiers,
            oldMarketingChannelValues,
            newMarketingChannelValues,
            0,
            claimOrders,
            lifeCycle,
            lifeCycle_UI,
            relatedTranslations,
            qualifierTranslations,
            backTranslations,
            textExist,
            this.currentPage
          )
          .then((result: any) => {
            console.log('result', result);
            this.loadingService.setLoading(false);
            // this.router.navigate(['/result'], {
            //   state: {
            //     fileDetails: this.fileDetails,
            //     data: result,
            //     resultPageTableData: this.originalReport,
            //     isExcel: false,
            //     flow: 'retake',
            //   },
            // });
            console.log('file details', this.fileDetails);
            const responseData = [
              {
                claims_la: [],
                fileBase64: this.originalReport.fileBase64,
                iRA_button_enable: true,
                new_marketing_channels: [],
                new_qualifiers: this.originalReport.qualifiers,
                iraresultsdata: result,
              },
            ];
            this.router.navigate(['/result'], {
              state: {
                data: responseData,
                isExcel: false,
                fileDetails: this.fileDetails,
                marketingChannel: this.marketingChannelsPreview,
                pageFrom: 'ira',
                source: 'Draft',
                navigatedFrom: 'home',
              },
            });
            // this.dataSource.data = result.results;

            //  const resultValues = result.results.map((value)=>{
            //     return {
            //       ...value,
            //       level:value.level,
            //       level_keywords:value.level_keywords,
            //       level_model:value.level_model,
            //       risk:value.risk,
            //       risk_keywords:value.risk_keywords,
            //       risk_model:value.risk_model,
            //       reason:value.reason,
            //       reason_keywords:value.reason_keywords,
            //       reason_model:value.reason_model
            //     }
            //   });
            //   const iraAssessData = {
            //     disclaimers:result.disclaimers,
            //     qualifiers:result.disclaimers,
            //     fileBase64:result.fileBase64,
            //     images:result.images,
            //     metadata:result.metadata,
            //     results: resultValues,
            //     text:result.text,
            //     timestamp:result.timestamp

            //   }
            //   console.log('iraAssessData',iraAssessData)
            //   this.resultsTableData(iraAssessData);
            // this.dataSource._updateChangeSubscription();
            // this.cdr.detectChanges();
          })
          .catch((err) => {
            this.loadingService.setLoading(false);
            console.log(err);
          });

        this.isTextModified = false;
        this.dataSource.data.forEach((row) => (row.isEdited = false));
      } else {
        this.router.navigate(['/home']);
      }
    });
  }

  toggleRow() {
    this.isRowVisible = !this.isRowVisible;
    console.log('test');
    this.cdr.detectChanges();
  }

  // toggleRow() {
  //   if (this.isToggleDisabled) {
  //     return;
  //   }
  //   this.isRowVisible = !this.isRowVisible;
  //   console.log('test');
  //   this.cdr.detectChanges();
  // }

  /* To toggle translate   */
  toggleTranslationGroup() {
    this.showTranlsationGroup = !this.showTranlsationGroup;
    if (this.showTranlsationGroup) {
      this.showLanguageGroup = false;
    }
  }

  toggleIraGroup() {
    this.showLanguageGroup = !this.showLanguageGroup;
    if (this.showLanguageGroup) {
      this.showTranlsationGroup = false;
    }
  }

  getLanguages() {
    const data = {
      environment: localStorage.getItem('environment'),
      session_id: sessionStorage.getItem('sessionId'),
    };

    this.homeService.getLanguages(data).subscribe((response: any) => {
      let responseArr: string[] = response.map((data: any) => data.country);

      if (this.geographyData.length > 0) {
        const languages = this.geographyData
          .map((geo) => geo.country_language)
          .flat();
        this.languagesData = [...new Set(languages)]; // Remove duplicates
      } else {
        this.languagesData = responseArr;
      }

      // Sort languages alphabetically, keeping English at the top
      this.languagesData = this.languagesData
        .filter((lang) => lang !== 'English') // Remove English temporarily
        .sort(); // Sort the remaining languages alphabetically

      this.languagesData.unshift('English'); // Add English back to the top

      // this.selectedLanguage = 'English';
      // localStorage.setItem('language', this.selectedLanguage);
    });
  }

  /**
   when radio button selection change in the translation section
   */
  onRadioButtonChange() {
    this.relatedStatementChecked = true;
    this.radioBtnValue = 'translation';
    if (this.relatedStatementChecked) {
      this.addTranslationRow();
    } else {
      this.relatedStatementChecked = false;
      localStorage.removeItem('translationLanguage');
      this.dataSource.data = this.dataSource.data.map(
        ({ translation_sr_no, translated_text, isNew, ...rest }) => {
          return rest;
        }
      );
    }
  }

  isAllSelected() {
    // const numSelected = this.selection.selected.length;
    // const numRows = this.dataSource.data.length;
    // return numSelected === numRows;
    let numRows = 0;
    if (this.dataSource.data.length > 0) {
      this.dataSource.data.forEach((row) => {
        if (row.selected == true) {
          numRows++;
        }
      });
    }
    return numRows === this.dataSource.data.length;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.dataSource.data.forEach((row) => {
        row.selected = false;
      });
    } else {
      this.selection.clear();
      this.dataSource.data.forEach((row) => {
        this.selection.select(row);
        row.selected = true;
      });
    }
  }

  getClaims() {
    this.generateClaimOrders();
  }

  /**to generate claim orders */
  generateClaimOrders() {
    console.log('data source', this.dataSource.data);
    const result = this.dataSource.data.reduce(function (r, a) {
      r[a.master_exist] = r[a.master_exist] || [];
      r[a.master_exist].push(a);
      return r;
    }, Object.create(null));

    if (Object.keys(result).length > 0) {
      result['true'].map((value, index) => {
        value.claimOrder = (index + 1) * 10;
      });
    }
  }

  /* when checkbox selection changes */
  changeSelection(row, index) {
    this.dataSource.data[index].selected = !row.selected;
    this.selection.clear();
    this.dataSource.data.forEach((value) => {
      if (value.selected == true) {
        this.selection.select(value);
      }
    });
  }

  /**reset all functionality */
  resetAll() {
    console.log('original report', this.originalReport);
    // const dialogRef = this.dialog.open(WarningPopupComponent, {
    //   width: '370px',
    //   height: '190px',
    //   disableClose: true,
    // });
    // dialogRef.afterClosed().subscribe((data) => {
    //   if (data == true) {
    // this.isTranslationRowAdded = false;
    // this.initialChange = true;
    // const dialogRef = this.dialog.open(IraAlertPopupComponent, {
    //   // width: '370px',
    //   // height: '190px',
    //   width: '28.7em',
    //   height: '14em',
    //   disableClose: true,
    //   data: {
    //     message: 'Are you sure you want to reset all changes?',
    //     messageType: 'msgNotify',
    //   },
    // });
    // dialogRef.afterClosed().subscribe((data) => {
    // console.log('data', data);
    // if (data == true) {
    // this.btnClicked = false;
    // this.relatedStatementChecked = false;
    // this.radioBtnValue = '';
    // this.defaultLanguageDisbaled = true;
    // this.selectedTranslationLanguage = undefined;
    //remove localStorage value for translation language
    localStorage.removeItem('translationLanguage');
    this.selectedLanguage = localStorage.getItem('language');
    //to reset back translation checkbox based on the language selected in the home page
    if (this.selectedLanguage == 'English') {
      this.backtranslationChecked = false;
      this.radioBtnValue = '';
    } else {
      this.backtranslationChecked = true;
      this.radioBtnValue = 'backtranslation';
    }

    if (this.fileType == '' || this.originalReport?.qualifiers?.length == 0) {
      this.isFormatted = true;
    } else {
      this.isFormatted = false;
    }

    //to reset back translation column based on the language selected in the home page
    if (this.displayedColumns.includes('backtranslation')) {
      if (this.selectedLanguage == 'English') {
        const qualifierIndex = this.displayedColumns.indexOf('qualifier');
        this.displayedColumns.splice(qualifierIndex + 1, 1);
      }
    } else {
      if (this.selectedLanguage != 'English') {
        const backtranslation = 'backtranslation';
        const qualifierIndex = this.displayedColumns.indexOf('qualifier');
        this.displayedColumns.splice(qualifierIndex + 1, 0, backtranslation);
      }
    }
    //to set language selected in result page
    console.log('original report', this.originalReport);
    const mtStatements = this.originalReport.results.map((value, i) => ({
      ...value,
      sl_no: this.formatSerialNumber(i + 1),
      allQualifier: this.existingQualifierValues[i],
      qualifiers:
        this.fileType == '' || this.originalReport?.qualifiers?.length > 0
          ? value?.existing_qualifier
            ? value?.existing_qualifier.join(',')
            : value?.qualifiers
          : [],
      allMarketingChannels: [
        ...value.marketing_channel,
        ...value.new_marketing_channel,
      ],
      translated_text: [],
      translated_qualifier_text: [],
      back_translated_text: [],
      selected_translated_text: [],
      selected_back_translated_text: [],
      selected_translated_qualifier_text: [],
      richtext: false,
      isNewRow: false,
      selected: true,
      isEdited: false,
      manual_reason: ['NA'],
    }));
    console.log(
      'Manual Reason after reset:',
      mtStatements.map((m) => m.manual_reason)
    );

    this.dataSource.data = mtStatements;
    // const masterExistTableData = mtStatements.filter((data) => {
    //   return data.master_exist == true;
    // });
    // to merge both old and new marketing channels
    // this.dataSource.data = masterExistTableData.map((value, i) => {
    //   return {
    //     allMarketingChannels: [...value.marketing_channel],
    //     ...value,
    //   };
    // });
    this.selection.clear();
    this.dataSource.data.forEach((row, index) => {
      // Below two line for proceed button enable after resetall click
      row.isEdited = false;
      this.isTextEditor[index] = false;

      this.selection.select(row);
    });

    //Recalculate isTextModified these lines also for proceed button
    this.isTextModified = this.dataSource.data.some(
      (row) => row.isEdited === true
    );

    this.selectedQualifiersUpdated.length = 0;
    this.dataSource._updateChangeSubscription();
    // this.getClaims();
    this.showTranlsationGroup = false;
    this.showLanguageGroup = false;

    this.selectedQualifiersUpdated.length = 0;
    // this.existingDataSource._updateChangeSubscription();
    this.dataSource._updateChangeSubscription();
    // this.getClaims();
    this.showTranlsationGroup = false;

    this.showLanguageGroup = false;

    // this.showIra = false;

    // }
    // });

    // Reset isEdited flag and update isTextModified
    this.dataSource.data.forEach((row, index) => {
      row.isEdited = false;
      this.isTextEditor[index] = false;
    });

    this.isTextModified = false;
    //   }
    // });
  }

  /**to get marketing channel dropdown data */
  getMarketingChannels() {
    this.previewService.getMarketingChannelData().subscribe((response: any) => {
      const marketingChannelsData = response.text;
      marketingChannelsData.map((value) => {
        this.marketingChannelsValues.push({
          type: '',
          text: value.marketchannel,
          icon: '',
        });
      });
    });
  }

  // To clear the statement text data in search bar

  getUniquemarketingChannels(): string[] {
    console.log('datasource', this.dataSource.data);
    const allChannels = this.dataSource.data.flatMap(
      (item) => item.allMarketingChannels || []
    );

    return Array.from(new Set(allChannels));
  }

  /**function to convert drodpwon to text box */
  formatQualifier() {
    this.isFormatted = true;
    let mappedTexts: any = [];
    this.selectedQualifiers.forEach(function (item: any, i) {
      var existing = mappedTexts.filter(function (v: any, i) {
        return v.index == item.index;
      });
      if (existing.length) {
        var existingIndex = mappedTexts.indexOf(existing[existing.length - 1]);
        mappedTexts[existingIndex].texts = item.texts;
      } else {
        if (typeof item.texts == 'string') item.texts = [item.texts];
        mappedTexts.push(item);
      }
    });

    // this.init = {
    //   setup: (editor) => {
    //     editor.on('init', () => {});
    //   },
    //   extended_valid_elements: 'b,i',
    //   formats: {
    //     bold: { inline: 'b' },
    //     italic: { inline: 'i' },
    //     underline: { inline: 'u' },
    //   },
    //   height: 100,
    //   branding: false,
    //   menubar: false,
    //   resize: false,
    //   statusbar: false,
    //   font_family_formats: 'Inter Medium = inter medium',
    //   content_style:
    //     '@import url(https://db.onlinewebfonts.com/c/234d23830d4b4e8a08fdf491981b4b1f?family=Unilever+Shilling);body { font-size:11px ;color:black; }',
    //   outputFormat: 'html',
    //   plugins: 'fullscreen',
    //   toolbar:
    //     'bold italic underline fullscreen  | formatselect | undo redo |\
    //  alignleft aligncenter alignright alignjustify | \
    //  bullist numlist outdent indent | removeformat  ',
    // };

    this.dataSource._updateChangeSubscription();
  }

  /**to get selected qualifier values */
  getSelectedQualifiers(event, rowindex) {
    console.log('event', event.source.triggerValue);
    let qualifierValues: any = [];
    if (event.source.selected.length > 0) {
      qualifierValues.push({
        index: rowindex,
        texts: event.source.triggerValue.split(', '),
      });
    }

    this.selectedQualifiers = qualifierValues;

    const quals = this.selectedQualifiers.reduce((obj, item) => {
      obj[item.index]
        ? (obj[item.index].texts = [[...obj[item.index].texts, ...item.texts]])
        : (obj[item.index] = { ...item, texts: [item.texts] });
      return obj;
    }, []);

    this.dataSource.data[rowindex].qualifiers = quals[rowindex]?.texts[0];

    this.selectedQualifiersUpdated[rowindex] = quals[rowindex]?.texts;
    this.selectedQualifiersUpdated = this.selectedQualifiersUpdated.map(
      (item) => {
        return item === undefined ? null : item;
      }
    );
    this.autoSaveSubject.next(); // Resets the timer
    this.dataSource.data[rowindex].isUpdated = true;
    console.log('data source', this.dataSource.data);
    this.dataSource._updateChangeSubscription();
  }

  /**to get selected marketing channels */
  // getSelectedMarketingChannels(event, index) {
  //   this.autoSaveSubject.next(); // Resets the timer
  //   this.dataSource.data[index].isUpdated = true;
  //   this.selectedMarketingChannels.push(event.source.triggerValue.split(', '));
  // }

  getSelectedMarketingChannels(event, index) {
    this.autoSaveSubject.next(); // Resets the timer
    this.dataSource.data[index].isUpdated = true;

    const newChannels = event.source.triggerValue.split(', ');

    newChannels.forEach((channel) => {
      if (!this.selectedMarketingChannels.includes(channel)) {
        this.selectedMarketingChannels.push(channel);
      }
    });
  }

  /**to add new row to the table */
  addNewRow() {
    console.log('in func');
    let maxClaimOrder;
    if (this.dataSource.data.length > 0) {
      maxClaimOrder = Math.max(
        ...this.dataSource.data.map((row) => row.claimOrder)
      );
    } else if (this.dataSource.data.length > 0) {
      maxClaimOrder = Math.max(
        ...this.dataSource.data.map((row) => row.claim_order)
      );
    } else {
      maxClaimOrder = 0;
    }

    const defaultMarketingChannel =
      this.dataSource.data.length > 0
        ? this.dataSource.data[0].marketing_channel
        : [];

    //qualifier editing status
    let qualifier_status: any;
    if (this.dataSource.data.length > 0) {
      qualifier_status =
        this.dataSource.data[0].qualifiers == true ? true : false;
    } else {
      qualifier_status = true;
    }

    //marketing channel editing status
    let marketing_channel_status: any;
    if (this.dataSource.data.length > 0) {
      marketing_channel_status =
        this.dataSource.data[0].marketing_channel == true ? true : false;
    } else {
      marketing_channel_status = true;
    }

    // let sr_no: number;
    // if (this.dataSource.data.length > 0) {
    //   if (
    //     this.dataSource.data.every(
    //       (row) => row.master_exist === true && row.project_exist === true
    //     )
    //   ) {
    //     const maxSrNo = Math.max(
    //       ...this.originalReport[0].claims_la.map((o) => o.sr_no)
    //     );
    //     sr_no = maxSrNo + 1;
    //   } else if (
    //     this.dataSource.data.some(
    //       (row) => row.master_exist === true && row.project_exist === false
    //     )
    //   ) {
    //     const maxSrNo = Math.max(...this.dataSource.data.map((o) => o.sr_no));
    //     sr_no = maxSrNo + 1;
    //   } else if (this.dataSource.data.some((row) => row.isNewRow === true)) {
    //     const maxSrNo = Math.max(...this.dataSource.data.map((o) => o.sr_no));
    //     sr_no = maxSrNo + 1;
    //   } else {
    //     sr_no = 1;
    //   }
    // } else {
    //   sr_no = 1;
    // }

    const newRow = {
      hideAlert: true,
      image: 'NULL',
      manual_reason: [[]], // Add your value here
      manual_level: [],
      manual_risk: [],
      Label: 'text',
      page_no: 0,
      level_keywords: [],
      level_model: 0,
      level: '',
      risk_keywords: [],
      risk_model: 0,
      risk: '',
      reason_keywords: [],
      reason_model: 0,
      reason: [],
      allQualifier: [],
      allMarketingChannels: [],
      sl_no: this.formatSerialNumber(this.dataSource.data.length + 1),
      text: '',
      existing_qualifier: [],
      qualifiers: [],
      new_marketing_channel: [],
      marketing_channel: [],
      claimOrder: maxClaimOrder + 10,
      translated_text: [],
      back_translated_text: [],
      selected_translated_text: [],
      selected_translated_qualifier_text: [],
      selected_back_translated_text: [],
      project_exist: '',
      master_exist: '',
      assessed_state: '',
      assessed_state_backend: '',
      text_lifecycles: 'None',
      text_lifecycles_UI: 'None',
      editing_status_qualifier: true,
      editing_status_mc: true,
      editing_status_statement: true,
      editing_status: {
        existing_qualifier: qualifier_status,
        marketing_channel: marketing_channel_status,
        text: true,
      },
      isNewRow: true,
      isNewlyAdded: true,
      isFieldsDisabled: true,
      richtext: false,
      isUpdated: false,
      isEdited: false,
      qualifiersFormControl: new FormControl([]),
      selected: true,
      statement_language: localStorage.getItem('language'),

      la_qualifier: [],
      la_local_qualifier: [],
      la_text: [''],
      la_local_text: [],
      la_lifecycle_ui: 'None',
      la_lifecycle: 'None',
      la_field_editing_status: {
        statement_text__v: true,
        qualifier__c: qualifier_status,
        marketing_channels__c: marketing_channel_status,
      },
      la_language_UI: 'English',
      la_local_language_UI: '',
      la_claim_id: '',
      la_related_id: '',
      la_statement_id: '',
    };
    this.dataSource.data = [...this.dataSource.data, newRow];
    this.selection.clear();
    this.dataSource.data.forEach((row) => {
      if (row.selected == true) {
        this.selection.select(row);
      }
    });

    this.emitAnyRowEdited();

    this.newlyAddedRowDeleted = false;
    this.cdr.detectChanges();
    this.dataSource._updateChangeSubscription();
    this.scrollToBottom();
  }

  /**to confirm to delete newly added row from the table */
  confirmDeleteRow(index: number, height: string = '27em') {
    const dialogRef = this.dialog.open(IraAlertPopupComponent, {
      // width: '30%',
      // height: height,
      width: '27.5em',
      height: height,

      disableClose: true,
      data: { project: true, messageType: 'deleteRow' },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.deleteRow(index);
      }
    });
  }
  /**to delete newly added row */
  deleteRow(index) {
    this.dataSource.data[index].selected = false;
    this.dataSource.data.splice(index, 1);
    this.selection.selected.splice(index, 1);
    this.emitAnyRowEdited();
    this.dataSource._updateChangeSubscription();
    this.cdr.detectChanges();
    this.newlyAddedRowDeleted = true;
    this.reassignSrNo();
    console.log('dataaaaaaaaaaaaaaaaaaafound ', this.dataSource.data);
  }

  reassignSrNo() {
    if (this.dataSource.data.length > 0) {
      // Get the highest sl_no among existing (non-new) rows
      const existingRows = this.dataSource.data.filter((row) => !row.isNewRow);
      const baseSrNo =
        existingRows.length > 0
          ? Math.max(
              ...existingRows.map((row) => this.formatSerialNumber(row.sl_no))
            )
          : 0;

      // Reassign sl_no for new rows starting from baseSrNo + 1
      let srNoCounter = baseSrNo + 1;

      this.dataSource.data.forEach((row) => {
        if (row.isNewRow === true) {
          row.sl_no = this.formatSerialNumber(srNoCounter++);
          row.translation_sr_no = `${this.formatSerialNumber(row.sl_no)}.1`;
        }
      });
    }
  }

  scrollToBottom() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.tableContainer?.nativeElement) {
          const container = this.tableContainer.nativeElement;
          container.scrollTop = container.scrollHeight;
        }
      }, 0); // 0ms ensures it runs after DOM update
    });
  }

  /*when user clicks on extended icon(...) then the icons are dispalying
    but when we scroll then we must hide
    */
  ngAfterViewInit() {
    if (this.tableContainer?.nativeElement) {
      this.tableContainer.nativeElement.addEventListener('scroll', () => {
        this.closeExtendedPanel();
      });
    }
  }
  closeExtendedPanel() {
    this.dataSource.data.forEach((value) => {
      value.richtext = false; // Disable rich text editor
    });

    // Optionally, reset editor content or hide any custom UI
  }
  //to close marketing channel select search box when click outside
  onMarketingChannelDropdownClosed() {
    this.showMarketingFilter = false;
  }

  /**toggle between translation and backtranslation */
  toggle(event: any) {
    console.log('event', event);

    console.log(this.initialChange);
    // if (this.initialChange) {
    this.initialChange = false;
    this.radioBtnValue = event.value;
    if (event.value == 'translation') {
      this.relatedStatementChecked = true;
      this.backtranslationChecked = false;
      this.defaultLanguageDisbaled = false;
      this.showTranslatedRows = true;
      this.statementLanguage = 'English';
      console.log('this.statementLanguage', this.statementLanguage);
      // Update all rows or specific ones
      // this.dataSource.data.forEach((row) => {
      //   row.statement_language = 'English';
      // });

      console.log(' this.statementLanguage ', this.statementLanguage);
      this.statementLanguageDisabled = true;
      this.onTranslationLanguageChange();
      if (this.displayedColumns.includes('backtranslation')) {
        const qualifierIndex = this.displayedColumns.indexOf('qualifier');
        this.displayedColumns.splice(qualifierIndex + 1, 1);
      }
    } else if (event.value == 'backtranslation') {
      this.backtranslationChecked = true;
      this.relatedStatementChecked = false;
      this.defaultLanguageDisbaled = true;
      this.statementLanguage = '';
      this.statementLanguageDisabled = false;
      localStorage.removeItem('translationLanguage');
      this.dataSource.data = this.dataSource.data.map(
        ({ translation_sr_no, translated_text, isNew, ...rest }) => {
          return rest;
        }
      );
      this.dataSource.data.forEach((row, index) => {
        row.selected_translated_text = [];
        row.selected_translated_qualifier_text = [];
        if (row.selected == true) {
          this.selection.select(row);
        }
      });
      this.addColumn();
      // }
      // return;
    }

    // const dialogRef = this.dialog.open(WarningPopupComponent, {
    //   width: '370px',
    //   height: '190px',
    //   disableClose: true,
    // });
    // dialogRef.afterClosed().subscribe((data) => {
    // if (data == true) {
    // if (event.value == 'translation') {
    //   this.relatedStatementChecked = true;
    //   this.backtranslationChecked = false;
    //   this.defaultLanguageDisbaled = false;

    //   this.onRadioButtonChange();
    //   if (this.displayedColumns.includes('backtranslation')) {
    //     const qualifierIndex = this.displayedColumns.indexOf('qualifier');
    //     this.displayedColumns.splice(qualifierIndex + 1, 1);
    //   }
    // } else if (event.value == 'backtranslation') {
    //   this.backtranslationChecked = true;
    //   this.relatedStatementChecked = false;
    //   this.defaultLanguageDisbaled = true;

    //   localStorage.removeItem('translationLanguage');
    //   this.dataSource.data = this.dataSource.data.map(
    //     ({ translation_sr_no, translated_text, isNew, ...rest }) => {
    //       return rest;
    //     }
    //   );
    //   this.dataSource.data.forEach((row, index) => {
    //     row.selected_translated_text = [];
    //     row.selected_translated_qualifier_text = [];
    //     if (row.selected == true) {
    //       this.selection.select(row);
    //     }
    //   });
    //   this.addColumn();
    // }
    // } else {
    // if (event.value == 'translation') {
    //   this.relatedStatementChecked = false;
    //   this.backtranslationChecked = true;
    //   this.defaultLanguageDisbaled = true;
    //   this.radioBtnValue = 'backtranslation';
    // } else if (event.value == 'backtranslation') {
    //   this.backtranslationChecked = false;
    //   this.relatedStatementChecked = true;
    //   this.defaultLanguageDisbaled = false;
    //   this.radioBtnValue = 'translation';
    // }
    // }
    // });

    this.dataSource._updateChangeSubscription();
  }

  /**
   when radio button selection change in the translation section
   */
  onTranslationLanguageChange(selectedTranslationLanguage?) {
    console.log('selectedTranslationLanguage', selectedTranslationLanguage);
    console.log('radiobtn', this.radioBtnValue);
    this.relatedStatementChecked = true;
    this.radioBtnValue = 'translation';
    console.log('relatedStatementChecked', this.relatedStatementChecked);
    if (this.relatedStatementChecked) {
      if (this.routeSource == 'Draft') {
        this.onRelatedStatementClick();
      } else {
        this.addTranslationRow();
      }
    } else {
      this.relatedStatementChecked = false;
      localStorage.removeItem('translationLanguage');
      this.dataSource.data = this.dataSource.data.map(
        ({ translation_sr_no, translated_text, isNew, ...rest }) => {
          return rest;
        }
      );
    }
  }

  /**to add translations row */
  addTranslation(flow: string) {
    // const translationRowExist = this.selection.selected.some((data) => {
    //   return (
    //     this.selection.selected[this.dataSource.data.length - 1].isNew ==
    //     undefined
    //   );
    // });

    // if (routeSrc === 'Draft') {
    //   let isTranslatedRow = this.dataSource.data.some((data) => {
    //     return data.translated_text.length > 0;
    //   });

    //   console.log('isTranslatedRow', isTranslatedRow);
    //   if (isTranslatedRow) {
    //     this.relatedStatementChecked = true;
    //     this.backtranslationChecked = false;
    //     this.defaultLanguageDisbaled = false;
    //   }
    // }

    // if (this.selection.selected.length > 0 && translationRowExist) {
    //   const dialogRef = this.dialog.open(WarningTranslationComponent, {
    //     width: '400px',
    //     height: '220px',
    //     disableClose: true,
    //   });
    //   dialogRef.afterClosed().subscribe((data) => {
    //     if (data == true) {
    //       if (this.relatedStatementChecked == true) {
    //         this.onRelatedStatementClick();
    //       } else if (this.backtranslationChecked == true) {
    //         this.addColumn();
    //         this.getBackTranslationData();
    //       } else {
    //         this.onRelatedStatementClick();
    //       }
    //     }
    //   });
    // } else {
    if (flow == 'translation') {
      this.relatedStatementChecked = true;
    } else if (flow == 'backtranslation') {
      this.backtranslationChecked = true;
    }
    console.log('related statement checked', this.relatedStatementChecked);
    // Allow adding translations without warning popup
    if (this.relatedStatementChecked == true) {
      this.onRelatedStatementClick();
    } else if (this.backtranslationChecked == true) {
      this.addColumn();
      this.getBackTranslationData();
    }
    //   else {
    //     this.onRelatedStatementClick();
    // }
    return this.dataSource.data;
  }

  /**translation radio button is selected */
  onRelatedStatementClick() {
    // if (this.selectedTranslationLanguage && this.relatedStatementChecked) {
    this.getTranslationRow();
    // }
  }

  /**to add translation row */
  addTranslationRow() {
    // Check if a row has already been added
    this.isTranslationRowAdded = true;
    this.dataSource.data = this.dataSource.data.map((row, index) => {
      return {
        translation_sr_no: this.formatSerialNumber(row.sl_no) + '.1',
        text: row?.text,
        translated_text: row.translated_text,
        isNew: true,
        ...row,
      };
    });

    this.selection.clear();
    this.dataSource.data.forEach((row, index) => {
      row.translated_text = [];
      row.selected_translated_text = [];
      row.qualifier_translated_text = [];
      row.selected_translated_qualifier_text = [];
      if (row.selected == true) {
        this.selection.select(row);
      }
    });
    this.statementLanguage = this.dataSource.data.map(() => 'English');

    this.dataSource._updateChangeSubscription();
    console.log('Translation row added:', this.dataSource.data);
  }

  // adding translation row
  // addTranslationRow() {
  //   if (!this.isTranslationRowAdded) {
  //     this.isTranslationRowAdded = true;

  //     let newDataIndex = 0; // Index to track srno of new rows
  //     this.dataSource.data = this.dataSource.data.map((row, index) => {
  //       return {
  //         translation_slno: row.slno + '.1',
  //         text: row?.text,
  //         translated_text: row.translated_text,
  //         isNew: true,
  //         ...row,
  //       };
  //     });

  //     this.selection.clear();
  //     this.dataSource.data.forEach((row, index) => {
  //       if (row.selected == true) {
  //         this.selection.select(row);
  //       }
  //     });

  //     this.statementLanguage = this.dataSource.data.map(() => 'English');

  //     this.dataSource._updateChangeSubscription();
  //   }
  // }
  /**to get translation row data after clicking on Populate Translation button*/

  getTranslationRow() {
    console.log('in func', this.selectedLanguage);

    this.btnClicked = true;
    let statements: any = [];
    let tableData: any = [];
    let qualifierData: any = [];

    this.selectedTranslationLanguage = localStorage.getItem(
      'translationLanguage'
    );

    console.log(
      'selectedTranslationLanguage',
      this.selectedTranslationLanguage
    );
    console.log('data source', this.dataSource.data);

    tableData = this.dataSource.data.filter((row) => {
      statements.push(row.text);

      if (typeof row.qualifiers == 'string') {
        qualifierData.push(this.sanitizeHTML(row.qualifiers));
      } else {
        qualifierData.push(row.qualifiers.join(', '));
      }

      return row;
    });

    /** payload data and response for qualifier translation */
    const qualifierdata = {
      text: qualifierData,
      input_language: [this.selectedLanguage],
      output_language: this.selectedTranslationLanguage,
      environment: localStorage.getItem('environment'),
    };

    this.loadingService.setLoading(true);
    this.resultService
      .getTranslateBulk(qualifierdata)
      .subscribe((response: any) => {
        this.qualifierTranslationData = response;
        // this.loadingService.setLoading(false);
      });
    // this.loadingService.setLoading(true);
    const data = {
      text_ext: statements,
      input_language: [this.selectedLanguage],
      translate_language: this.selectedTranslationLanguage,
      session_id: sessionStorage.getItem('sessionId'),
      action: 'related',
      environment: localStorage.getItem('environment'),
    };
    // this.loadingService.setLoading(true);
    this.resultService.getTranslations(data).subscribe((response: any) => {
      const originalQualifierValues = this.dataSource.data.map(
        (row) => row.qualifiers
      );

      tableData.forEach((data, index) => {
        this.selectedQualifiersUpdated[index] =
          this.selectedQualifiersUpdated[index] || [];
      });

      this.dataSource.data = this.dataSource.data.map((row, index) => {
        const translatedText: any = [];
        const backTranslatedText: any = [];
        const qualifierTransaltedText: any = [];

        let objIndex = response.findIndex(
          (temp) => temp['input_statement'] === row.text
        );

        if (response[objIndex].related_statement.length > 0) {
          response[objIndex].related_statement.forEach((value) => {
            translatedText.push({
              type: 'normal',
              text: value,
              icon: '',
            });
          });
        }

        translatedText.push({
          type: 'ai',
          text: [...response[objIndex].azure_translation],
          icon: '../../../../assets/images/icons/azure-translator.png',
        });

        // if (this.backtranslationChecked == true) {
        //   if (response[objIndex].back_statement.length > 0) {
        //     response[objIndex].back_statement.forEach((value) => {
        //       if (row.text == response[objIndex].input_statement) {
        //         backTranslatedText.push({
        //           type: 'normal',
        //           text: value,
        //           icon: '',
        //         });
        //       }
        //     });
        //   }

        //   backTranslatedText.push({
        //     type: 'ai',
        //     text: [...response[objIndex].azure_translation_back_statement],
        //     icon: 'fa-robot',
        //   });
        // }

        let qualifierObjIndex = this.qualifierTranslationData.filter((temp) => {
          if (typeof row.qualifiers == 'string') {
            if (
              this.sanitizeHTML(temp.input_text) ==
              this.sanitizeHTML(row.qualifiers)
            ) {
              qualifierTransaltedText.splice(index, 0, {
                type: 'ai',
                text: this.sanitizeHTML(
                  temp.azure_translate_text.replace(/\n/g, ',')
                ),
                icon: '../../../../assets/images/icons/azure-translator.png',
              });
            }
          } else {
            if (row.qualifiers.length > 0) {
              if (
                this.sanitizeHTML(temp.input_text) ==
                this.sanitizeHTML(row.qualifiers.join(', '))
              ) {
                qualifierTransaltedText.splice(index, 0, {
                  type: 'ai',
                  text: this.sanitizeHTML(temp.azure_translate_text),
                  icon: '../../../../assets/images/icons/azure-translator.png',
                });
              }
            }
          }
        });

        // to remove duplicate array object values and keep the latest values
        var qualifierTransaltedTextResult = qualifierTransaltedText.reduce(
          (unique, o) => {
            const existingIndex = unique.findIndex(
              (obj) => obj.text === o.text
            );
            if (existingIndex !== -1) {
              unique[existingIndex] = o; // update the existing object with the latest values
            } else {
              unique.push(o);
            }
            return unique;
          },
          []
        );

        console.log('translatedtext', translatedText);
        console.log(
          'qualifierTransaltedTextResult',
          qualifierTransaltedTextResult
        );
        row.translated_text = translatedText;
        row.selected_translated_text = [];
        row.back_translated_text = backTranslatedText || [];
        // to set backtranslation value by default if only one value available
        if (row.back_translated_text.length == 1) {
          row.selected_back_translated_text = row.back_translated_text[0].text;
        } else {
          row.selected_back_translated_text = [];
        }
        row.translated_qualifier_text = qualifierTransaltedTextResult || [];
        row.selected_translated_qualifier_text = [];
        this.translatedTexts[index] = row.translated_text;
        this.backTranslatedTexts[index] = row.back_translated_text;

        return {
          allMarketingChannels: [
            ...row.marketing_channel,
            ...row.new_marketing_channel,
          ],
          translation_sr_no: this.formatSerialNumber(row.sl_no) + '.1',
          text: row?.text,
          translated_text: row.translated_text,
          isNew: true,
          ...row,
        };
      });
      this.loadingService.setLoading(false);
      this.selection.clear();
      this.dataSource.data.forEach((row, index) => {
        if (row.selected == true) {
          this.selection.select(row);
        }
      });
      console.log('new data source', this.dataSource.data);
    });

    this.dataSource._updateChangeSubscription();
  }

  //  /**to get selected newly added translation text */
  getSelectedTrasnlation(event, index) {
    // if (event == undefined) {
    //   this.dataSource.data[index].selected_translated_text = [];
    // } else {
    //   if (event?.label != undefined) {
    //     this.dataSource.data[index].selected_translated_text = event?.label;
    //   } else {
    this.autoSaveSubject.next(); // Resets the timer
    this.dataSource.data[index].selected_translated_text = event;
    this.dataSource.data[index].isUpdated = true;
    //   }
    // }
  }

  // /**to add new translations */
  // addNewTranslations(rowIndex, text) {
  //   const textArr: any = [];
  //   textArr.push(text);

  //   this.translatedTexts[rowIndex] = [
  //     ...this.dataSource.data[rowIndex].translated_text,
  //     {
  //       type: 'normal',
  //       text: [...textArr],
  //       icon: '',
  //     },
  //   ];
  //   this.dataSource.data[rowIndex].translated_text.push({
  //     type: 'normal',
  //     text: [...textArr],
  //     icon: '',
  //   });
  //   this.dataSource.data[rowIndex].statement_language =
  //     this.selectedTranslationLanguage;
  //   this.dataSource.data[rowIndex].selected_translated_text = [...textArr];

  //   return textArr;
  // }

  /**to get selected newly added qualifier translation text */
  getSelectedQualifierTrasnlation(event, index) {
    console.log('event', event);
    console.log('type of event', typeof event);
    // if (event == undefined) {
    //   this.dataSource.data[index].selected_translated_qualifier_text = [];
    // } else {
    //   if (event?.label != undefined) {
    //     this.dataSource.data[index].selected_translated_qualifier_text =
    //       event?.label;
    //   } else {
    //this.dataSource.data[index].selected_translated_qualifier_text = event;
    // }
    // }
    this.autoSaveSubject.next(); // Resets the timer
    if (typeof event == 'object') {
      this.dataSource.data[index].selected_translated_qualifier_text = event;
    } else {
      this.dataSource.data[index].selected_translated_qualifier_text = [event];
    }
    this.dataSource.data[index].isUpdated = true;
  }

  // /**to add new translations */
  // addNewQualifierTranslations(rowIndex, text) {
  //   const textArr: any = [];
  //   textArr.push(text);

  //   this.translatedQualifierTexts[rowIndex] = [
  //     ...this.dataSource.data[rowIndex].translated_qualifier_text,
  //     {
  //       type: 'normal',
  //       text: [...textArr],
  //       icon: '',
  //     },
  //   ];
  //   this.dataSource.data[rowIndex].translated_qualifier_text.push({
  //     type: 'normal',
  //     text: [...textArr],
  //     icon: '',
  //   });
  //   this.dataSource.data[rowIndex].statement_language =
  //     this.selectedTranslationLanguage;
  //   this.dataSource.data[rowIndex].selected_translated_qualifier_text = [
  //     ...textArr,
  //   ];

  //   return textArr;
  // }

  /**to add new column in the table when backtranslation option is selected */
  addColumn() {
    if (this.backtranslationChecked) {
      const backtranslation = 'backtranslation';
      if (!this.displayedColumns.includes(backtranslation)) {
        const qualifierIndex = this.displayedColumns.indexOf('qualifier');
        this.displayedColumns.splice(qualifierIndex + 1, 0, backtranslation);
      }
      if (this.selectedLanguage == 'English') {
        this.dataSource.data.forEach((row, index) => {
          row.backTranslationColumn = true;
        });
      }
    } else {
      // const dialogRef = this.dialog.open(WarningPopupComponent, {
      //   width: '370px',
      //   height: '190px',
      //   disableClose: true,
      // });

      // dialogRef.afterClosed().subscribe((data) => {
      //   if (data == true) {
      const columnIndex = this.displayedColumns.indexOf('backtranslation');
      if (columnIndex !== -1) {
        this.displayedColumns.splice(columnIndex, 1);
        this.dataSource.data.forEach((row, index) => {
          row.selected_back_translated_text = [];
          row.back_translated_text = [];
          row.backTranslationColumn = false;
        });
      }
      // } else {
      //   this.backtranslationChecked = true;
      // }
      // });

      this.dataSource._updateChangeSubscription();
    }
  }

  /**to load data in the backtranslation column when add translation button is clicked */
  getBackTranslationData() {
    this.btnClicked = true;
    let statements: any = [];
    let languageBacktranslation: any = [];
    console.log('this.isEditClaimsRoute ', this.isEditClaimsRoute);
    if (this.isEditClaimsRoute == 'editClaims') {
      this.dataSource.data.forEach((value) => {
        statements.push(value.text);
        languageBacktranslation.push(value.statement_languages);
      });
    } else {
      this.dataSource.data.forEach((value) => {
        statements.push(value.text);
      });
    }

    // this.dataSource.data.forEach((value) => {
    //   statements.push(value.text);
    // });
    const data = {
      text_ext: statements,
      // statement_language: [this.selectedLanguage],
      statement_language:
        this.isEditClaimsRoute == 'editClaims'
          ? languageBacktranslation
          : [this.selectedLanguage],

      session_id: sessionStorage.getItem('sessionId'),
      action: 'backtranslation',
      environment: localStorage.getItem('environment'),
    };
    this.loadingService.setLoading(true);
    this.resultService.getBackTranslations(data).subscribe((response) => {
      // const tableData = this.originalReport[0].claims_la.filter((value) => {
      //   return value.master_exist == true;
      // });

      // //to remove duplicate array object values
      // var uniqueData = this.selection.selected.reduce((unique, o) => {
      //   if (!unique.some((obj) => obj.sl_no === o.sl_no)) {
      //     unique.push(o);
      //   }
      //   return unique;
      // }, []);

      // //sort based on claim order
      // const uniqueSortedData = uniqueData.sort(
      //   (a, b) => a.claimOrder - b.claimOrder
      // );

      this.dataSource.data = this.dataSource.data.map((data, index) => {
        console.log('data', data);
        const backTranslatedText: any = [];
        if (response[index].back_statement.length > 0) {
          if (response[index].back_statement != null) {
            backTranslatedText.push({
              type: 'normal',
              text: [...response[index].back_statement],
              icon: '',
            });
          }
        }
        if (response[index].azure_translation[0] == '') {
          backTranslatedText.push({
            type: 'ai',
            text: [''],
            icon: '../../../../assets/images/icons/azure-translator.png',
          });
        } else {
          backTranslatedText.push({
            type: 'ai',
            text: [...response[index].azure_translation],
            icon: '../../../../assets/images/icons/azure-translator.png',
          });
        }

        this.backTranslatedTexts[index] = backTranslatedText;
        data.back_translated_text = backTranslatedText;
        if (this.routeSource == 'Draft') {
          data.selected_back_translated_text =
            data.selected_back_translated_text;
        } else {
          // to set backtranslation value by default if only one value available
          if (data.back_translated_text.length == 1) {
            data.selected_back_translated_text =
              data.back_translated_text[0].text;
          } else {
            data.selected_back_translated_text = [];
          }
        }
        // if(this.routeSource == 'Draft'){
        //   data.selected_back_translated_text = ;
        // }
        data.translated_text = [];

        return {
          ...data,
          allMarketingChannels: [
            ...data.marketing_channel,
            ...data.new_marketing_channel,
          ],
        };
      });

      this.selection.clear();
      this.dataSource.data.forEach((row, index) => {
        if (row.selected == true) {
          this.selection.select(row);
        }
        this.backTranslatedTexts[index] = row.back_translated_text;
      });
      this.loadingService.setLoading(false);
    });

    this.dataSource._updateChangeSubscription();
  }

  // /**to add new backtrasnlation */
  // addNewBackTranslations(rowIndex, text) {
  //   const textArr: any = [];
  //   textArr.push(text);
  //   this.backTranslatedTexts[rowIndex] = [
  //     ...this.dataSource.data[rowIndex].back_translated_text,
  //     {
  //       type: 'normal',
  //       text: [...textArr],
  //       icon: '',
  //     },
  //   ];
  //   this.dataSource.data[rowIndex].back_translated_text.push({
  //     type: 'normal',
  //     text: [...textArr],
  //     icon: '',
  //   });
  //   this.dataSource.data[rowIndex].statement_language =
  //     this.selectedLanguage;
  //   this.dataSource.data[rowIndex].selected_back_translated_text = [
  //     ...textArr,
  //   ];

  //   return textArr;
  // }

  /**to set newly added backtranslation  */
  getSelectedBackTrasnlation(event, index) {
    // if (event == undefined) {
    //   this.dataSource.data[index].selected_back_translated_text = [];
    // } else {
    //   if (event?.label != undefined) {
    //     this.dataSource.data[index].selected_back_translated_text =
    //       event?.label;
    //   } else {
    //this.dataSource.data[index].selected_back_translated_text = event;
    //   }
    // }
    this.autoSaveSubject.next(); // Resets the timer
    if (event == null) {
      //to clear the selected back translated text
      this.dataSource.data[index].selected_back_translated_text = [];
    } else {
      this.dataSource.data[index].selected_back_translated_text = event;
    }
  }

  /**to get the claims data from IRA and navigate it to confirm page */
  async saveClaimsIra(routeData) {
    // const dialogRef = this.dialog.open(EeocChangesLostMessageComponent, {
    //   width: '370px',
    //   height: '190px',
    //   disableClose: true,
    // });
    // dialogRef.afterClosed().subscribe((data) => {
    //   // if click on confirm button
    //   if (data == true) {
    this.loadingService.setLoading(true);
    console.log('route data', routeData);
    console.log('table data', this.dataSource.data);
    console.log('original report data', this.originalReport);
    setTimeout(() => {
      // Add claimsToReview check
      if (this.activeClaimsCount > 0) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // dialogConfig.height = '180px';
        // dialogConfig.width = '400px';
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Please review the claim(s) before proceeding.`,
            buttons: [{ id: 'OK', text: 'OK' }],
            submitButtonId: 'OK',
            type: PopupType.ERROR,
            messageType: 'duplicateVeeva',
          } as any);
        this.dialog
          .open(IraAlertPopupComponent, dialogConfig)
          .afterClosed()
          .subscribe(() => {});
        this.loadingService.setLoading(false);
        return;
      }
      let selectedRows: any = [];
      this.selection.clear();
      this.dataSource.data.forEach((value) => {
        if (value.selected == true) {
          this.selection.select(value);
        }
      });
      console.log('selected data', this.selection.selected);
      // to remove qualifiers form control property from Result Array
      const selectedUpdatedArray = this.selection.selected.filter((obj) => {
        delete obj.qualifiersFormControl;
        return obj;
      });

      // to add qualifiers inside array if its a string
      const finalTableData = selectedUpdatedArray.map((value) => {
        if (typeof value.qualifiers == 'string') {
          value.qualifiers = [value.qualifiers];
        }

        return value;
      });

      // to remove duplicate array object values and keep the latest values
      var result = finalTableData.reduce((unique, o) => {
        const existingIndex = unique.findIndex((obj) => obj.sl_no === o.sl_no);
        if (existingIndex !== -1) {
          unique[existingIndex] = o; // update the existing object with the latest values
        } else {
          unique.push(o);
        }
        return unique;
      }, []);

      // //check whether backtranslation is added or not if language is non-english
      // const languageValue = localStorage.getItem('language');
      // let allBackTranslationSelected: boolean;
      // // if (languageValue != 'English') {
      // console.log('result', result);
      // allBackTranslationSelected = result.every((row) => {
      //   return (
      //     row.selected_back_translated_text.length > 0 &&
      //     this.radioBtnValue == 'backtranslation'
      //   );
      // });
      // // }
      // // else {
      // //   allBackTranslationSelected = true;
      // // }

      // console.log('allBackTranslationSelected', allBackTranslationSelected);
      // if (allBackTranslationSelected == true) {
      //   const dialogConfig = new MatDialogConfig();
      //   dialogConfig.disableClose = true;
      //   (dialogConfig.height = '180px'),
      //     (dialogConfig.width = '400px'),
      //     (dialogConfig.data = {
      //       message: `Please select backtranslation value for all the rows to continue further.`,
      //       buttons: [{ id: 'OK', text: 'COMMON.OK' }],
      //       submitButtonId: 'OK',
      //       type: PopupType.ERROR,
      //       messageType: 'duplicateVeeva',
      //     } as any);
      //   this.dialog
      //     .open(IraAlertPopupComponent, dialogConfig)
      //     .afterClosed()
      //     .subscribe((response) => {});
      //   return;
      // }

      //check if there is any get data icon is present in table

      const hasImageData = result.some((row) => {
        return row.isEdited == true || row.isFieldsDisabled == true;
      });

      if (hasImageData) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // (dialogConfig.height = '180px'),
        //   (dialogConfig.width = '400px'),
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Please get the data for the edited statement text before proceeding further`,
            buttons: [{ id: 'OK', text: 'COMMON.OK' }],
            submitButtonId: 'OK',
            type: PopupType.ERROR,
            messageType: 'duplicateVeeva',
          } as any);
        this.dialog
          .open(IraAlertPopupComponent, dialogConfig)
          .afterClosed()
          .subscribe((response) => {});
        this.loadingService.setLoading(false);
        return;
      }
      //check if there is any row is selected or not
      const selectedRow = result.some((row) => {
        return row.selected == true;
      });
      console.log('selectedRow', selectedRow);
      if (selectedRow == false) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // (dialogConfig.height = '180px'),
        //   (dialogConfig.width = '400px'),
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Please select atleast one checkbox`,
            buttons: [{ id: 'OK', text: 'COMMON.OK' }],
            submitButtonId: 'OK',
            type: PopupType.ERROR,
            messageType: 'duplicateVeeva',
          } as any);
        this.dialog
          .open(IraAlertPopupComponent, dialogConfig)
          .afterClosed()
          .subscribe((response) => {});
        this.loadingService.setLoading(false);
        return;
      }
      // Check if any row has an empty text field
      const hasEmptyText: boolean = result.some(
        (row) => row.text == '' && row.selected == true
      );

      const hasEmptyTranslation: boolean = result.some(
        (row) =>
          row.selected_translated_qualifier_text?.length > 0 &&
          row.selected_translated_text?.length == 0
      );

      //check dupliacates
      const textValues: any = [];
      const languageData: any = [];
      //get texts from table data
      result.forEach((value) => {
        if (value.selected == true) {
          textValues.push(value.text);
          languageData.push(value.statement_language);
        }
      });
      //payload for check_duplicates API
      const data = {
        text: textValues,
        input_language: languageData,
        session_id: sessionStorage.getItem('sessionId'),
        environment: localStorage.getItem('environment'),
      };

      this.sharedService
        .checkDuplicatesData(data)
        .subscribe(async (res: any) => {
          if (res.duplicates.length > 0) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            // (dialogConfig.height = '35%'),
            //   (dialogConfig.width = '370px'),
            (dialogConfig.height = '14em'),
              (dialogConfig.width = '28.7em'),
              (dialogConfig.data = {
                headerText: `Duplicate Texts Found.`,
                messageLines: [`'${res.duplicates.join('<br>')}'`],
                lowerText: 'Please Remove the Duplicates to Proceed Further.',
                buttons: [{ id: 'OK', text: 'COMMON.OK' }],
                //message: ` '${res.duplicates.join(', ')}' `,
                submitButtonId: 'OK',
                type: PopupType.ERROR,
                messageType: 'duplicateVeeva',
              } as any);
            this.dialog
              .open(IraAlertPopupComponent, dialogConfig)
              .afterClosed()
              .subscribe((response) => {});
            this.loadingService.setLoading(false);
            return;
          } else {
            if (!hasEmptyText && !hasEmptyTranslation) {
              // this.originalReport[0].claims_la = [
              //   ...this.existingDataSource.data,
              //   ...this.dataSource.data,
              // ];
              console.log('original report', this.originalReport);
              console.log('result', result);
              console.log('data source', this.dataSource.data);
              // console.log('page from ira', this.pageFromIra);
              try {
                console.log('Saving draft...');
                //await this.saveDraftIra(routeData.fileDetails);
                this.loadingService.setLoading(true);
                try {
                  await this.saveDraftIra(this.fileDetails);
                } finally {
                  this.loadingService.setLoading(false);
                }
                console.log('Draft saved. Navigating now...');
                console.log('router from', this.routeFrom);
                console.log('isEditClaimsRoute', this.isEditClaimsRoute);
                this.loadingService.setLoading(true);
                this.router.navigate(['/ira-confirmation'], {
                  state: {
                    data: result,
                    documentData:
                      this.originalReport.fileBase64 ||
                      this.originalReport.fileBase64[0],
                    replaceUrl: true,
                    backtranslationtext: this.backtranslationChecked,
                    responseData: this.originalReport,
                    fileDetails: routeData.fileDetails,
                    previewMarketingChannels:
                      routeData.previewMarketingChannels,
                    routeFrom: routeData.routeFromData,
                    editClaimsNormalRoute: this.editClaimsNormalRoute,
                  },
                });
              } catch (error) {
                console.error('Failed to save draft:', error);
                this.loadingService.setLoading(false);
                // Optionally show an error popup
              }
            } else {
              if (hasEmptyTranslation) {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                // (dialogConfig.height = '35%'),
                //   (dialogConfig.width = '370px'),
                (dialogConfig.height = '14em'),
                  (dialogConfig.width = '28.7em'),
                  (dialogConfig.data = {
                    message: `Kindly Select The Translated Statement Text For The Selected Qualifier Translation To Proceed Further `,
                    // icon: './assets/img/icons/stop-icon.svg',
                    buttons: [
                      // { id: 'CANCEL', text: 'COMMON.CANCEL' },
                      { id: 'SAVE', text: 'OK' },
                    ],
                    submitButtonId: 'OK',
                    messageType: 'duplicateVeeva',
                    type: PopupType.INFO,
                  } as any);
                this.dialog
                  .open(IraAlertPopupComponent, dialogConfig)
                  .afterClosed();
              } else {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                // (dialogConfig.height = '35%'),
                //   (dialogConfig.width = '370px'),
                (dialogConfig.height = '14em'),
                  (dialogConfig.width = '28.7em'),
                  (dialogConfig.data = {
                    message: `Kindly Uncheck The Empty Statement Checkbox To Proceed Further `,
                    // icon: './assets/img/icons/stop-icon.svg',
                    buttons: [
                      // { id: 'CANCEL', text: 'COMMON.CANCEL' },
                      { id: 'SAVE', text: 'OK' },
                    ],
                    submitButtonId: 'OK',
                    messageType: 'duplicateVeeva',
                    type: PopupType.INFO,
                  } as any);
                this.dialog
                  .open(IraAlertPopupComponent, dialogConfig)
                  .afterClosed();
              }
            }
            this.loadingService.setLoading(false);
          }
        });
    }, 0);
    //   }
    // });
  }

  /**to get local adptation data which needs to be saved and navigate it to ira confirm page */
  async saveLocalAdaptationIra(routeDetails) {
    console.log('la ira');
    // const dialogRef = this.dialog.open(EeocChangesLostMessageComponent, {
    //   width: '370px',
    //   height: '190px',
    //   disableClose: true,
    // });
    // dialogRef.afterClosed().subscribe((data) => {
    //   // if click on confirm button
    //   if (data == true) {
    this.loadingService.setLoading(true);
    setTimeout(() => {
      // Add claimsToReview check
      if (this.activeClaimsCount > 0) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // dialogConfig.height = '180px';
        // dialogConfig.width = '400px';
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Please review the local adaptation(s) before proceeding.`,
            buttons: [{ id: 'OK', text: 'OK' }],
            submitButtonId: 'OK',
            type: PopupType.ERROR,
            messageType: 'duplicateVeeva',
          } as any);
        this.dialog
          .open(IraAlertPopupComponent, dialogConfig)
          .afterClosed()
          .subscribe(() => {});
        this.loadingService.setLoading(false);
        return;
      }
      let selectedRows: any = [];
      this.selection.clear();
      this.dataSource.data.forEach((value) => {
        if (value.selected == true) {
          this.selection.select(value);
        }
      });
      // to remove qualifiers form control property from Result Array
      const selectedUpdatedArray = this.selection.selected.filter((obj) => {
        delete obj.qualifiersFormControl;
        return obj;
      });

      // to add qualifiers inside array if its a string
      const finalTableData = selectedUpdatedArray.map((value) => {
        if (typeof value.qualifiers == 'string') {
          value.qualifiers = [value.qualifiers];
        }

        return value;
      });

      // to remove duplicate array object values and keep the latest values
      var result = finalTableData.reduce((unique, o) => {
        const existingIndex = unique.findIndex((obj) => obj.sl_no === o.sl_no);
        if (existingIndex !== -1) {
          unique[existingIndex] = o; // update the existing object with the latest values
        } else {
          unique.push(o);
        }
        return unique;
      }, []);

      //check whether backtranslation is added or not if language is non-english
      const languageValue = localStorage.getItem('language');
      let allBackTranslationSelected: boolean;
      if (languageValue != 'English') {
        allBackTranslationSelected = result.every((row) => {
          return row.selected_back_translated_text.length > 0;
        });
      } else {
        allBackTranslationSelected = true;
      }

      // if (allBackTranslationSelected == false) {
      //   const dialogConfig = new MatDialogConfig();
      //   dialogConfig.disableClose = true;
      //   (dialogConfig.height = '180px'),
      //     (dialogConfig.width = '400px'),
      //     (dialogConfig.data = {
      //       message: `Please select backtranslation value for all the rows to continue further.`,
      //       buttons: [{ id: 'OK', text: 'COMMON.OK' }],
      //       submitButtonId: 'OK',
      //       type: PopupType.ERROR,
      //       messageType: 'duplicateVeeva',
      //     } as any);
      //   this.dialog
      //     .open(IraAlertPopupComponent, dialogConfig)
      //     .afterClosed()
      //     .subscribe((response) => {});
      //   return;
      // }

      //check if there is any get data icon is present in table
      const hasImageData = result.some((row) => {
        return row.isEdited == true || row.isFieldsDisabled == true;
      });

      if (hasImageData) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // (dialogConfig.height = '180px'),
        //   (dialogConfig.width = '400px'),
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Please get the data for the edited statement text before proceeding further`,
            buttons: [{ id: 'OK', text: 'COMMON.OK' }],
            submitButtonId: 'OK',
            type: PopupType.ERROR,
            messageType: 'duplicateVeeva',
          } as any);
        this.dialog
          .open(IraAlertPopupComponent, dialogConfig)
          .afterClosed()
          .subscribe((response) => {});
        this.loadingService.setLoading(false);
        return;
      }

      //check if there is any row is selected or not
      const selectedRow = result.some((row) => {
        return row.selected == true;
      });
      console.log('selectedRow', selectedRow);
      if (selectedRow == false) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        // (dialogConfig.height = '180px'),
        //   (dialogConfig.width = '400px'),
        (dialogConfig.height = '14em'),
          (dialogConfig.width = '28.7em'),
          (dialogConfig.data = {
            message: `Please select atleast one checkbox`,
            buttons: [{ id: 'OK', text: 'COMMON.OK' }],
            submitButtonId: 'OK',
            type: PopupType.ERROR,
            messageType: 'duplicateVeeva',
          } as any);
        this.dialog
          .open(IraAlertPopupComponent, dialogConfig)
          .afterClosed()
          .subscribe((response) => {});
        this.loadingService.setLoading(false);
        return;
      }

      // Check if any row has an empty text field
      const hasEmptyText = result.some(
        (row) => row.text === '' && row.selected == true
      );

      const hasEmptyTranslation: boolean = result.some(
        (row) =>
          row.selected_translated_qualifier_text?.length > 0 &&
          row.selected_translated_text?.length == 0
      );

      //check dupliacates

      const textValues: any = [];
      const languageData: any = [];
      //get texts from table data
      result.forEach((value) => {
        if (value.selected == true) {
          textValues.push(value.text);
          languageData.push(value.statement_language);
        }

        //textValues.push(value.text);
      });
      //payload for check_duplicates API
      const data = {
        text: textValues,
        input_language: languageData,
        session_id: sessionStorage.getItem('sessionId'),
        environment: localStorage.getItem('environment'),
      };

      this.sharedService
        .checkDuplicatesData(data)
        .subscribe(async (res: any) => {
          if (res.duplicates.length > 0) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            // (dialogConfig.height = '35%'),
            //   (dialogConfig.width = '370px'),
            (dialogConfig.height = '14em'),
              (dialogConfig.width = '28.7em'),
              (dialogConfig.data = {
                headerText: `Duplicate Texts Found.`,
                messageLines: [`'${res.duplicates.join('<br>')}'`],
                lowerText: 'Please Remove the Duplicates to Proceed Further.',
                buttons: [{ id: 'OK', text: 'COMMON.OK' }],
                submitButtonId: 'OK',
                messageType: 'duplicateVeeva',
                type: PopupType.ERROR,
              } as any);
            this.dialog
              .open(IraAlertPopupComponent, dialogConfig)
              .afterClosed()
              .subscribe((response) => {});
            this.loadingService.setLoading(false);
            return;
          } else {
            if (!hasEmptyText && !hasEmptyTranslation) {
              // this.originalReport[0].claims_la = [
              //   ...this.existingDataSource.data,
              //   ...this.dataSource.data,
              // ];
              console.log('result', result);
              try {
                console.log('Saving draft...');

                // await this.saveDraftIra(this.fileDetails);
                this.loadingService.setLoading(true);
                try {
                  await this.saveDraftIra(this.fileDetails);
                } finally {
                  this.loadingService.setLoading(false);
                }
                this.loadingService.setLoading(true);
                // this.saveDraftResult(this.fileDetails);
                console.log('result', result);
                console.log('router from', this.routeFrom);
                console.log('isEditClaimsRoute', this.isEditClaimsRoute);
                this.router.navigate(['/ira-confirmation'], {
                  state: {
                    data: result,
                    documentData:
                      this.originalReport.fileBase64[0] ||
                      this.originalReport.fileBase64,
                    replaceUrl: true,
                    backtranslationtext: this.backtranslationChecked,
                    responseData: this.originalReport,
                    fileDetails: routeDetails.fileDetails,
                    previewMarketingChannels:
                      routeDetails.previewMarketingChannels,
                    routeFrom: routeDetails.routeFromData,
                    geographies: this.geographyDataLA,
                    editClaimsNormalRoute: this.editClaimsNormalRoute,
                  },
                });
              } catch (error) {
                console.error('Failed to save draft:', error);
                this.loadingService.setLoading(false);
                // Optionally show an error popup
              }
            } else {
              if (hasEmptyTranslation) {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                // (dialogConfig.height = '35%'),
                //   (dialogConfig.width = '370px'),
                (dialogConfig.height = '14em'),
                  (dialogConfig.width = '28.7em'),
                  (dialogConfig.data = {
                    message: `Kindly Select The Translated Statement Text For The Selected Qualifier Translation To Proceed Further `,
                    // icon: './assets/img/icons/stop-icon.svg',
                    buttons: [
                      // { id: 'CANCEL', text: 'COMMON.CANCEL' },
                      { id: 'SAVE', text: 'OK' },
                    ],
                    submitButtonId: 'OK',
                    messageType: 'duplicateVeeva',
                    type: PopupType.INFO,
                  } as any);
                this.dialog
                  .open(IraAlertPopupComponent, dialogConfig)
                  .afterClosed();
              } else {
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                // (dialogConfig.height = '35%'),
                //   (dialogConfig.width = '370px'),
                (dialogConfig.height = '14em'),
                  (dialogConfig.width = '28.7em'),
                  (dialogConfig.data = {
                    message: `Kindly Uncheck The Empty Statement Checkbox To Proceed Further `,
                    // icon: './assets/img/icons/stop-icon.svg',
                    buttons: [
                      // { id: 'CANCEL', text: 'COMMON.CANCEL' },
                      { id: 'SAVE', text: 'OK' },
                    ],
                    submitButtonId: 'OK',
                    messageType: 'duplicateVeeva',
                    type: PopupType.INFO,
                  } as any);
                this.dialog
                  .open(IraAlertPopupComponent, dialogConfig)
                  .afterClosed();
              }
            }
            this.loadingService.setLoading(false);
          }
        });
    }, 0);
    // this.loadingService.setLoading(false);
    //   }
    // });
  }

  formatSerialNumber(num) {
    return num.toString().padStart(2, '0');
  }

  getImageDetails(file: File): Promise<string> {
    return Converters.toBase64(file);
  }

  async saveDraftIra(fileDetails, event?: any) {
    console.log('fileDetails', fileDetails);
    // if (event) {

    // const dialogRef = this.dialog.open(IraAlertPopupComponent, {
    //   // width: '370px',
    //   // height: '190px',
    //   width: '27.5em',
    //   height: '27em',
    //   disableClose: true,
    //   data: {
    //     message: 'Do you want to save the current progress as a draft?',
    //     messageType: 'msgNotify',
    //     // Pass any data you need to the dialog here
    //   },
    // });

    // dialogRef.afterClosed().subscribe(async (result) => {
    //   if (result == true) {
    return new Promise(async (resolve, reject) => {
      try {
        let fileInfo: any;
        if (
          this.fileType == 0 ||
          fileDetails == undefined ||
          this.isEditClaimsRoute === 'editClaims'
        ) {
          fileInfo = '';
        } else {
          fileInfo = await this.getImageDetails(fileDetails);
        }

        let fileType: any;
        if (fileInfo.split(',')[0].includes('image/png')) {
          fileType = 'png';
        } else if (fileInfo.split(',')[0].includes('image/jpeg')) {
          fileType = 'jpeg';
        } else if (fileInfo.split(',')[0].includes('image/jpg')) {
          fileType = 'jpg';
        } else if (fileInfo.split(',')[0].includes('application/pdf')) {
          fileType = 'pdf';
        }

        const sanitizedResults = Converters.sanitizeObject([
          ...this.dataSource.data,
        ]);

        const cleanClaims = sanitizedResults.map((result) => {
          return {
            ...result,
            qualifiersFormControlValue: result.qualifiersFormControl?.value,
            qualifiersFormControl: undefined, // or remove this key entirely
          };
        });

        console.log('cleanClaims', cleanClaims);

        const textValues: any = [];
        const relatedTranslations: any = [];
        const qualifierTranslations: any = [];
        const backTranslations: any = [];
        const lifeCycle: any = [];
        const lifeCycle_UI: any = [];
        const textExist: any = [];
        const qualifiers: any = [];
        const oldMarketingChannels: any = [];
        const newMarketingChannels: any = [];
        const claimOrders: any = [];

        cleanClaims.forEach((val) => {
          // textValues.push(value.text);
          // relatedTranslations.push(value.selected_translated_text);
          // qualifierTranslations.push(
          //   value.selected_translated_qualifier_text
          // );
          // backTranslations.push(value.selected_back_translated_text);
          // lifeCycle.push(value.text_lifecycles);
          // lifeCycle_UI.push(value.text_lifecycles_UI);
          // textExist.push(value.text_exits);
          // qualifiers.push(value.qualifiers);
          // oldMarketingChannels.push(value.marketing_channel);
          // newMarketingChannels.push(value.new_marketing_channel);
          // claimOrders.push(value.claim_order);
          console.log('val', val);
          textValues.push(val.text);
          textExist.push(val.text_exits);
          claimOrders.push(val.claimOrder);

          //translation
          if (typeof val.selected_translated_text == 'string') {
            relatedTranslations.push([val.selected_translated_text]);
          } else {
            if (val.selected_translated_text.length > 0) {
              relatedTranslations.push(val.selected_translated_text);
            } else {
              relatedTranslations.push([]);
            }
          }

          //qualifier translation
          if (typeof val.selected_translated_qualifier_text == 'string') {
            qualifierTranslations.push([
              val.selected_translated_qualifier_text,
            ]);
          } else {
            if (val.selected_translated_qualifier_text.length > 0) {
              qualifierTranslations.push(
                val.selected_translated_qualifier_text
              );
            } else {
              qualifierTranslations.push([]);
            }
          }

          //back translation
          if (typeof val.selected_back_translated_text == 'string') {
            backTranslations.push([val.selected_back_translated_text]);
          } else {
            if (val.selected_back_translated_text.length > 0) {
              backTranslations.push(val.selected_back_translated_text);
            } else {
              backTranslations.push([]);
            }
          }

          //qualifier
          // if (typeof val.qualifiers == 'string') {
          //   val.qualifiers = [val.qualifiers];
          //   qualifiers.push(val.qualifiers);
          // } else {
          //   if (val.qualifiers.length > 0) {
          //     val.qualifiers.map((qualifier) => {
          //       if (qualifier == undefined || qualifier == null) {
          //         qualifiers.push([]);
          //       } else {
          //         qualifiers.push(qualifier);
          //       }
          //     });
          //   } else {
          //     qualifiers.push([]);
          //   }
          // }

          console.log(val.qualifiers, 'QAAAAAAAA');

          let processedQualifiers: any[] = [];
          if (typeof val.qualifiers === 'string') {
            processedQualifiers = [val.qualifiers];
          } else if (
            Array.isArray(val.qualifiers) &&
            val.qualifiers.length > 0
          ) {
            processedQualifiers = val.qualifiers.map((q) =>
              q == undefined || q == null ? [] : q
            );
          } else if (val.qualifier_veeva && val.qualifier_veeva !== 'NA') {
            processedQualifiers = Array.isArray(val.qualifier_veeva)
              ? val.qualifier_veeva
              : [val.qualifier_veeva];
          } else {
            processedQualifiers = [];
          }

          // Assign back to the claim object
          val.qualifiers = processedQualifiers;

          // If you still need a flat array of all qualifiers, you can push here:
          qualifiers.push(processedQualifiers);
          console.log('qualifiers:', qualifiers);

          //existing marketing channel
          if (val?.marketing_channel.length > 0) {
            oldMarketingChannels.push(val.marketing_channel);
          } else {
            oldMarketingChannels.push([]);
          }

          //new marketing channel
          if (val?.new_marketing_channel) {
            if (val?.new_marketing_channel.length > 0) {
              newMarketingChannels.push([
                ...new Set(val.new_marketing_channel),
              ]);
            } else {
              newMarketingChannels.push([]);
            }
          } else {
            newMarketingChannels.push([]);
          }

          //text lifecycle
          if (val.text_lifecycles == '') {
            lifeCycle.push('None');
          } else {
            lifeCycle.push(val.text_lifecycles);
          }

          //text lifecycle UI
          if (val.text_lifecycles_UI == '') {
            lifeCycle_UI.push('None');
          } else {
            lifeCycle_UI.push(val.text_lifecycles_UI);
          }
        });

        console.log('clean caliams', cleanClaims);

        const fileBase64 = [
          {
            document: this.originalReport.document,
            currentPage: this.originalReport.currentPage,
          },
        ];

        // const safeCoordinates = this.deepCloneWithoutCircular(
        //   this.originalReport?.fileBase64?.[0]?.coordinates.coordinates
        // );

        const rawCoordinates =
          this.originalReport?.fileBase64?.[0]?.coordinates.coordinates?.map(
            (coord) => ({
              Label: coord.Label,
              pageNumber: coord.pageNumber,
              region: {
                xmin: coord.region.xmin,
                ymin: coord.region.ymin,
                xmax: coord.region.xmax,
                ymax: coord.region.ymax,
              },
              isNew: coord.isNew,
            })
          );

        // const classifyImgpayload = {
        //   application: 'EEOC',
        //   Image: fileBase64,
        //   txt_ext: [textValues],
        //   data: { coordinates: safeCoordinates },
        //   doc_id: localStorage.getItem('docId'),
        //   eeoc_params: [
        //     {
        //       selected_translated_text: relatedTranslations,
        //       selected_translated_qualifier_text: qualifierTranslations,
        //       selected_back_translated_text: backTranslations,
        //       text_lifecycles: lifeCycle,
        //       text_lifecycles_UI: lifeCycle_UI,
        //       text_exits: textExist,
        //       qualifiers: qualifiers,
        //       marketing_channel: oldMarketingChannels,
        //       new_marketing_channel: newMarketingChannels,
        //       claimOrder: claimOrders,
        //     },
        //   ],
        //   project_id: localStorage.getItem('project'),
        //   product_id: localStorage.getItem('product'),
        //   country_id: localStorage.getItem('geography'),
        //   countries: [localStorage.getItem('geographyName')],
        //   session_id: sessionStorage.getItem('sessionId'),
        //   product_format: localStorage.getItem('productFormat'),
        //   environment: localStorage.getItem('environment'),
        //   user_id: localStorage.getItem('userId'),
        //   user_security_profile: localStorage.getItem('userRole'),
        // };

        const classifyImgpayload = {
          application: 'EEOC',
          Image: Array.isArray(fileBase64)
            ? fileBase64.map((f) => ({ ...f }))
            : [{}],
          txt_ext: [Array.isArray(textValues) ? [...textValues] : []],
          data: {
            coordinates: rawCoordinates,
          },
          doc_id: localStorage.getItem('docId'),
          eeoc_params: [
            {
              selected_translated_text: [...relatedTranslations],
              selected_translated_qualifier_text: [...qualifierTranslations],
              selected_back_translated_text: [...backTranslations],
              text_lifecycles: [...lifeCycle],
              text_lifecycles_UI: [...lifeCycle_UI],
              text_exits: [...textExist],
              qualifiers: [...qualifiers],
              marketing_channel: [...oldMarketingChannels],
              new_marketing_channel: [...newMarketingChannels],
              claimOrder: [...claimOrders],
            },
          ],
          project_id: localStorage.getItem('project'),
          product_id: localStorage.getItem('product'),
          country_id: localStorage.getItem('geography') || '',
          countries: [localStorage.getItem('geographyName')],
          session_id: sessionStorage.getItem('sessionId'),
          product_format: localStorage.getItem('productFormat'),
          environment: localStorage.getItem('environment'),
          user_id: localStorage.getItem('userId'),
          user_security_profile: localStorage.getItem('userRole'),
          business_group: localStorage.getItem('businessGroup'),
          user_role: localStorage.getItem('userRole'),
        };

        console.log('classifyImgpayload', classifyImgpayload);

        // Handle the result from the dialog
        const payloadData = {
          Userid: localStorage.getItem('userId'),
          Project: localStorage.getItem('project'),
          ProjectName: localStorage.getItem('projectName'),
          Product: localStorage.getItem('product'),
          ProductName: localStorage.getItem('productName'),
          Geography: localStorage.getItem('geography'),
          GeographyName: localStorage.getItem('geographyName'),
          Language: localStorage.getItem('language'),
          session_id: sessionStorage.getItem('sessionId'),
          environment: localStorage.getItem('environment'),
          AssetBytes: fileInfo,
          Page:
            this.editClaimsNormalRoute == 'editClaims'
              ? 'IRA_editclaims'
              : 'IRA',
          Json: {
            disclaimers: this.originalReport.disclaimers,
            fileBase64: this.originalReport.fileBase64,
            images: this.originalReport.images,
            metadata: this.originalReport.metadata,
            qualifiers: this.originalReport.qualifiers || [],
            results: cleanClaims,
            total: this.originalReport.total,
            timestamp: this.originalReport.timestamp,
            text: this.originalReport.text,
            payloadData: classifyImgpayload,
            translationLanguage: localStorage.getItem('translationLanguage'),
            [this.editClaimsNormalRoute === 'editClaims'
              ? 'edit_la'
              : 'claims_la']: this.originalReport.claims_la || [],
            iRA_button_enable: this.originalReport.iRA_button_enable || true,
            new_marketing_channels:
              this.originalReport.new_marketing_channels || [],
            new_qualifiers: this.originalReport.new_qualifiers || [],
            AssetFormat: fileType,
            businessGroup: localStorage.getItem('businessGroup'),
            categroy: localStorage.getItem('category'),
            isAssetExistInVeeva: localStorage.getItem('veevaAssetId')
              ? true
              : false,
            existingDocumentId: localStorage.getItem('veevaAssetId')
              ? localStorage.getItem('veevaAssetId')
              : '',
          },
        };

        console.log('payloadData', JSON.parse(JSON.stringify(payloadData)));

        // const cleanData = this.cleanObject(payloadData);
        // console.log('cleanData', cleanData);
        // const json = this.safeStringify(payloadData);
        // console.log('Sanitized JSON:', json);

        this.sharedService.saveDraftData(payloadData).subscribe({
          next: (response: any) => {
            resolve(response);
            if (event && response.Status == 'Success') {
              this.messageService.add({
                severity: 'success',
                summary: '',
                detail: 'Draft data saved successfully',
                key: 'br',
                life: 5000,
              });
            } else if (event && response.Status == 'Failure') {
              this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Draft data failed to save',
                key: 'br',
                life: 5000,
              });
            }
          },
          error: (error) => {
            reject(error);
          },
        });
      } catch (err) {
        reject(err);
      }
    });
    //   }
    // });
    // } else {
    //   let fileInfo: any;
    //   if (this.fileType == 0) {
    //     fileInfo = '';
    //   } else {
    //     fileInfo = await this.getImageDetails(fileDetails);
    //   }

    //   const cleanClaims = Converters.sanitizeObject([...this.dataSource.data]);
    //   console.log('cleanClaims', cleanClaims);
    //   const textValues: any = [];
    //   const relatedTranslations: any = [];
    //   const qualifierTranslations: any = [];
    //   const backTranslations: any = [];
    //   const lifeCycle: any = [];
    //   const lifeCycle_UI: any = [];
    //   const textExist: any = [];
    //   const qualifiers: any = [];
    //   const oldMarketingChannels: any = [];
    //   const newMarketingChannels: any = [];
    //   const claimOrders: any = [];

    //   cleanClaims.forEach((value) => {
    //     textValues.push(value.text);
    //     relatedTranslations.push(value.selected_translated_text);
    //     qualifierTranslations.push(value.selected_translated_qualifier_text);
    //     backTranslations.push(value.selected_back_translated_text);
    //     lifeCycle.push(value.text_lifecycle);
    //     lifeCycle_UI.push(value.text_lifecycle_UI);
    //     textExist.push(value.text_exist);
    //     qualifiers.push(value.qualifiers);
    //     oldMarketingChannels.push(value.marketing_channel);
    //     newMarketingChannels.push(value.new_marketing_channel);
    //     claimOrders.push(value.claim_order);
    //   });

    //   const fileBase64 = [
    //     {
    //       document: this.originalReport.document,
    //       currentPage: this.originalReport.currentPage,
    //     },
    //   ];

    //   const coordinates =
    //     this.originalReport?.fileBase64?.[0]?.coordinates.coordinates;
    //   const safeCoordinates = JSON.parse(JSON.stringify(coordinates));

    //   const classifyImgpayload = {
    //     application: 'EEOC',
    //     Image: fileBase64,
    //     txt_ext: [textValues],
    //     data: { coordinates: safeCoordinates },

    //     doc_id: localStorage.getItem('docId'),
    //     eeoc_params: [
    //       {
    //         selected_translated_text: relatedTranslations,
    //         selected_translated_qualifier_text: qualifierTranslations,
    //         selected_back_translated_text: backTranslations,
    //         text_lifecycles: lifeCycle,
    //         text_lifecycles_UI: lifeCycle_UI,
    //         text_exits: textExist,
    //         qualifiers: qualifiers,
    //         marketing_channel: oldMarketingChannels,
    //         new_marketing_channel: newMarketingChannels,
    //         claimOrder: claimOrders,
    //       },
    //     ],
    //     project_id: localStorage.getItem('project'),
    //     product_id: localStorage.getItem('product'),
    //     country_id: localStorage.getItem('geography'),
    //     countries: [localStorage.getItem('geographyName')],
    //     session_id: sessionStorage.getItem('sessionId'),
    //     product_format: localStorage.getItem('productFormat'),
    //     environment: localStorage.getItem('environment'),
    //     user_id: localStorage.getItem('userId'),
    //     user_security_profile: localStorage.getItem('userRole'),
    //   };

    //   console.log('classifyImgpayload', classifyImgpayload);
    //   // Handle the result from the dialog
    //   const payloadData = {
    //     Userid: localStorage.getItem('userId'),
    //     Project: localStorage.getItem('project'),
    //     ProjectName: localStorage.getItem('projectName'),
    //     Product: localStorage.getItem('product'),
    //     ProductName: localStorage.getItem('productName'),
    //     Geography: localStorage.getItem('geography'),
    //     GeographyName: localStorage.getItem('geographyName'),
    //     Language: localStorage.getItem('language'),
    //     session_id: sessionStorage.getItem('sessionId'),
    //     environment: localStorage.getItem('environment'),
    //     AssetBytes: fileInfo,
    //     Page: 'IRA',
    //     Json: {
    //       disclaimers: this.originalReport.disclaimers,
    //       fileBase64: this.originalReport.fileBase64,
    //       images: this.originalReport.images,
    //       metadata: this.originalReport.metadata,
    //       qualifiers: this.originalReport.qualifiers || [],
    //       results: cleanClaims,
    //       total: this.originalReport.total,
    //       timestamp: this.originalReport.timestamp,
    //       text: this.originalReport.text,
    //       payloadData: classifyImgpayload,
    //       translationLanguage: localStorage.getItem('translationLanguage'),
    //       claims_la: this.originalReport.claims_la || [],
    //       iRA_button_enable: this.originalReport.iRA_button_enable || true,
    //       new_marketing_channels:
    //         this.originalReport.new_marketing_channels || [],
    //       new_qualifiers: this.originalReport.new_qualifiers || [],
    //     },
    //   };

    //   console.log('payloadData', payloadData);
    //   this.sharedService
    //     .saveDraftData(payloadData)
    //     .subscribe((response: any) => {
    //       console.log('response', response);
    //     });
    // }
  }

  // safeClone(obj: any): any {
  //   const seen = new WeakSet();
  //   return JSON.parse(
  //     JSON.stringify(obj, (key, value) => {
  //       if (typeof value === 'object' && value !== null) {
  //         if (seen.has(value)) return;
  //         seen.add(value);
  //       }
  //       return value;
  //     })
  //   );
  // }

  deepCloneWithoutCircular(obj: any) {
    const seen = new WeakSet();
    return JSON.parse(
      JSON.stringify(obj, (key, value) => {
        if (typeof value === 'object' && value !== null) {
          if (seen.has(value)) return undefined;
          seen.add(value);
        }
        return value;
      })
    );
  }



  // Call this method whenever you want to notify parent about changes
  emitAnyRowEdited() {
    console.log('anyRowEdited', this.anyRowEdited);
    console.log('Emitting isAnyRowEdited:', this.isAnyRowEdited);
    console.log(
      'Row states:',
      this.dataSource.data.some((row) => ({
        isEdited: row.isEdited,
        isFieldsDisabled: row.isFieldsDisabled,
        isNewRow: row.isNewRow,
      }))
    );
    this.anyRowEdited.emit(this.isAnyRowEdited);
    console.log('isAnyRowEdited', this.isAnyRowEdited);
  }

  get isAnyRowEdited(): boolean {
    const editedText = this.dataSource?.data?.some(
      (element: any) =>
        element.isEdited ||
        ((element.isFieldsDisabled || element.isEdited) &&
          (element.isNewRow || element.isEdited))
    );
    //console.log('test',test)
    // Emit value to parent whenever checked

    const draftIcon =  this.dataSource?.data?.some(
      (element: any) =>
        element.matched_status == 'not matched')

      console.log('draftIcon',draftIcon)

    this.anyRowEdited.emit(editedText || draftIcon);
    return editedText || draftIcon;
  }

  getTableContainerClass() {
    if (this.isResultPage && this.rowVisibleIra && this.activeClaimsCount > 0) {
      return 'activeClaimsCount_rowVisible';
    }
    if (this.isResultPage && this.rowVisibleIra) {
      return 'tableContainer_translated_RowVisible';
    }
    if (
      this.isResultPage &&
      !this.rowVisibleIra &&
      this.activeClaimsCount > 0
    ) {
      return 'activeClaimsCount_rowhidden';
    }
    if (this.isResultPage && !this.rowVisibleIra) {
      return 'tableContainer_translated_RowHidden';
    }
    if (!this.isResultPage && !this.isRowVisible) {
      return 'tableContainer_translate_RowVisible';
    }
    if (!this.isResultPage && this.isRowVisible) {
      return 'tableContainer';
    }
    return '';
  }

  // detecting image loaded on UI & then showtext
  imageOnLoad(event, i, type) {
    const obj = { [`${type}-${i}`]: true };
    this.showText = obj;
  }

  // Add ngOnDestroy method
  private destroy$ = new Subject<void>(); // Add destroy subject
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.autoSaveSubject.complete(); // Also complete the autoSaveSubject
  }
}
